{
  "AnalyticsCoreStringId.Actions": "Eylemler",
  "AnalyticsCoreStringId.Category": "Kategori",
  "AnalyticsCoreStringId.Cmd_Copy": "&Kopyala",
  "AnalyticsCoreStringId.Cmd_Delete": "&Sil",
  "AnalyticsCoreStringId.Cmd_MoveDown": "Aşağı Taşı",
  "AnalyticsCoreStringId.Cmd_MoveUp": "Yukarı Taşı",
  "AnalyticsCoreStringId.Cmd_Paste": "Ya&pıştır",
  "AnalyticsCoreStringId.Cmd_Properties": "Ö&zellikler",
  "AnalyticsCoreStringId.CollectionEditor_Name_Placeholder": "Adı",
  "AnalyticsCoreStringId.CollectionEditor_Value_Placeholder": "Değer",
  "AnalyticsCoreStringId.DSWizard_Title": "Veri kaynağı Sihirbazı",
  "AnalyticsCoreStringId.EditCut": "Kes",
  "AnalyticsCoreStringId.ExpressionEditor_ExpressionCaption": "İfade Düzenleyici",
  "AnalyticsCoreStringId.ExpressionEditor_ItemInfo_Fields": "Alanlar",
  "AnalyticsCoreStringId.FieldListActions_AddParameter": "Parametre Ekle",
  "AnalyticsCoreStringId.FilePicker_Placeholder": "Dosya",
  "AnalyticsCoreStringId.FilterEditor_AdvancedMode": "Gelişmiş mod",
  "AnalyticsCoreStringId.FilterEditor_Operand_Type_Parameter": "Parametre",
  "AnalyticsCoreStringId.FilterEditor_Operand_Type_Property": "Özellik",
  "AnalyticsCoreStringId.FilterEditor_Operand_Type_Value": "Değer",
  "AnalyticsCoreStringId.FilterEditor_TreeCreationError": "Bu ifade için bir ağaç oluşturulamıyor",
  "AnalyticsCoreStringId.Font.Size": "Boyut",
  "AnalyticsCoreStringId.Font.Unit": "Birim",
  "AnalyticsCoreStringId.FormatFontName": "Yazı Tipi Adı",
  "AnalyticsCoreStringId.Group_Edit": "&Düzenle",
  "AnalyticsCoreStringId.GuidIsRequired_Error": "GUID gereklidir ve geçerli bir biçim olmalıdır.",
  "AnalyticsCoreStringId.ImagePicker_Placeholder": "Resim",
  "AnalyticsCoreStringId.JsonDSWizard_ChooseJsonSourcePage_Header": "Başlık",
  "AnalyticsCoreStringId.Loading": "Yükleniyor...",
  "AnalyticsCoreStringId.MenuButtons_Save": "Kaydet",
  "AnalyticsCoreStringId.Mobile_DateRange_SelectPeriod": "Seçin",
  "AnalyticsCoreStringId.NameIsRequired_Error": "Ad gereklidir ve geçerli bir tanımlayıcı olmalıdır.",
  "AnalyticsCoreStringId.ObjectDSWizard_ChooseDataMember_Description": "Bağlamak için tüm nesneyi veya veri üyesini seçin.",
  "AnalyticsCoreStringId.ObjectDSWizard_ChooseDataMember_Disabled_Description": "Bir veri üyesi seçmek için, en az bir veri üyesi içeren bir tür seçin.",
  "AnalyticsCoreStringId.ObjectDSWizard_ConfigureParameters_Description": "Yapıcı parametreleri ve/veya yöntem parametrelerini yapılandırın.",
  "AnalyticsCoreStringId.ObjectDSWizard_ConfigureParameters_Disabled_Description": "Parametreleri belirtmek için parametreli bir oluşturucu veya yöntem seçin.",
  "AnalyticsCoreStringId.ObjectDSWizard_ConfigureParameters_EntireObject": "Tüm Nesne",
  "AnalyticsCoreStringId.PaddingInfo.All": "Hepsi",
  "AnalyticsCoreStringId.PaddingInfo.Bottom": "Alt",
  "AnalyticsCoreStringId.PaddingInfo.Left": "Sol",
  "AnalyticsCoreStringId.PaddingInfo.Right": "Sağ",
  "AnalyticsCoreStringId.PaddingInfo.Top": "Üst",
  "AnalyticsCoreStringId.Parameter_Type_Boolean": "Boole",
  "AnalyticsCoreStringId.Parameter_Type_DateTime": "TarihSaat",
  "AnalyticsCoreStringId.Parameter_Type_Decimal": "Ondalık",
  "AnalyticsCoreStringId.Parameter_Type_Double": "Çift",
  "AnalyticsCoreStringId.Parameter_Type_Float": "Gezici",
  "AnalyticsCoreStringId.Parameter_Type_Guid": "GUID",
  "AnalyticsCoreStringId.Parameter_Type_Int16": "Sayı (16 bit tamsayı)",
  "AnalyticsCoreStringId.Parameter_Type_Int32": "Sayı (32 bit tamsayı)",
  "AnalyticsCoreStringId.Parameter_Type_Int64": "Sayı (64-bit tamsayı)",
  "AnalyticsCoreStringId.Parameter_Type_String": "Dize",
  "AnalyticsCoreStringId.ParametersPanel_False": "Hayır",
  "AnalyticsCoreStringId.ParametersPanel_True": "Evet",
  "AnalyticsCoreStringId.Prefix": "Önek",
  "AnalyticsCoreStringId.PropertyGrid_PopupMenu_Reset": "Sıfırla",
  "AnalyticsCoreStringId.QueryBuilder_LeftOperand": "Sol İşlenen",
  "AnalyticsCoreStringId.QueryBuilder_Parameters": "Değişkenler",
  "AnalyticsCoreStringId.QueryBuilder_RightOperand": "Sağ işlenen.",
  "AnalyticsCoreStringId.QueryBuilder_SearchBox_EmptyText": "aramak için metni girin",
  "AnalyticsCoreStringId.QueryBuilder_SelectAll": "Seçin tüm (*)",
  "AnalyticsCoreStringId.QueryBuilder_TableProperties": "Tablo Özellikleri",
  "AnalyticsCoreStringId.Redo": "&Yinele",
  "AnalyticsCoreStringId.SearchDialog_Cancel": "İptal",
  "AnalyticsCoreStringId.SelectAll": "(Tümünü Seç)",
  "AnalyticsCoreStringId.SizeF.Height": "Boy",
  "AnalyticsCoreStringId.SizeF.Width": "En",
  "AnalyticsCoreStringId.SqlDSWizard_PageConfigureMasterDetailRelations": "Ana-ayrıntı ilişkileri yapılandırma.",
  "AnalyticsCoreStringId.SqlDSWizard_QueryName": "Sorgu Adı",
  "AnalyticsCoreStringId.SqlDSWizard_Title": "Veri kaynağı Sihirbazı",
  "AnalyticsCoreStringId.TooltipButtons_Preview": "Önizleme",
  "AnalyticsCoreStringId.Undo": "&Geri Al",
  "AnalyticsCoreStringId.Wizard_ChooseDataSourceFromList": "Evet, listeden varolan bir veri kaynağını seçmeme izin ver",
  "AnalyticsCoreStringId.Wizard_ChooseDataSource_Description": "Raporunuzda kullanmak için bir veri kaynağı seçin.",
  "AnalyticsCoreStringId.Wizard_Finish": "Bitir",
  "AnalyticsCoreStringId.Wizard_Next": "Sonraki",
  "AnalyticsCoreStringId.Wizard_Previous": "Önceki",
  "AnalyticsCoreStringId.Wizard_UseExisting_DataSource": "Varolan bir veri kaynağını kullanmak istiyor musunuz?",
  "AnalyticsCoreStringId.Zoom": "Yaklaştır",
  "AnalyticsCoreStringId.ZoomIn": "Yaklaştır",
  "AnalyticsCoreStringId.ZoomOut": "Uzaklaştır",
  "DataAccessStringId.ColumnNotInSchemaValidationException": "Şema aşağıdaki sütunu içermiyor: \"{0}\". \"{1}\".",
  "DataAccessStringId.ConfigureMultiQueryPage_QueryCategory": "Sorgular",
  "DataAccessStringId.ConfigureMultiQueryPage_TableCategory": "Tablolar",
  "DataAccessStringId.ConnectingToDatabaseCaption": "Lütfen bekleyin",
  "DataAccessStringId.ConnectingToDatabaseMessage": "Veritabanına bağlanma",
  "DataAccessStringId.ConnectionStringPostfixAppConfig": "(yapılandırma dosyasında)",
  "DataAccessStringId.CustomExpressionWithColumnOfMissingTableValidationException": "Özel ifade içinde kullanılan sütun [{0}] içeren tablo yok.",
  "DataAccessStringId.CustomSqlQueryValidationException": "Özel bir SQL sorgusu yalnızca SELECT deyimleri içermelidir.",
  "DataAccessStringId.DatabaseConnectionExceptionMessage": "Bağlantı adı: {0}\nHata iletisi: {1}",
  "DataAccessStringId.DefaultNameDataSource": "Veri kaynağı",
  "DataAccessStringId.DefaultNameParameter": "Parametre",
  "DataAccessStringId.EFFilterControl_EmptyFilterString": "Filtre dizesi null olamaz.",
  "DataAccessStringId.EmptyColumnAliasPattern": "{0} Sütunu",
  "DataAccessStringId.ExcelDataSource_FileNotFoundMessage": "{0}\nDosya bulunamadı.\nDosya adını denetleyin ve yeniden deneyin.",
  "DataAccessStringId.ExcelEncryptedFileException_EncryptionTypeNotSupported": "Korumalı dosya açılamıyor.",
  "DataAccessStringId.ExcelEncryptedFileException_PasswordRequired": "Bu çalışma kitabını açmak için bir parola gerekiyor.",
  "DataAccessStringId.ExcelEncryptedFileException_WrongPassword": "Parola doğru değil. Lütfen yeniden deneyin.",
  "DataAccessStringId.ExcelInvalidFileException_BIFF5Format": "BIFF5 (Excel 5.0/95) XLS dosya biçimi desteklenmiyor.",
  "DataAccessStringId.ExcelInvalidFileException_CorruptedFile": "Dosya bozuk.",
  "DataAccessStringId.ExcelWizard_ValueSeparator_Comma": "Virgül",
  "DataAccessStringId.ExcelWizard_ValueSeparator_Space": "Boşluk",
  "DataAccessStringId.ExcelWizard_ValueSeparator_Tab": "Sekme",
  "DataAccessStringId.ExpressionEditor_Caption": "İfade Düzenleyici",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_ColumnDescriptionFormat": "Türü: {0}",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Columns": "Sütunlar",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Columns_Tooltip": "Sütun",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Constants": "Sabitler",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Custom": "Özel",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Functions": "Fonksiyonlar",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Operators": "Operatörler",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Operators_Tooltip": "operatör",
  "DataAccessStringId.ExpressionEditor_DocumentationCategory_Parameters": "Değişkenler",
  "DataAccessStringId.ExpressionEditor_FunctionCategory_Aggregate": "Toplama",
  "DataAccessStringId.ExpressionEditor_FunctionCategory_DateTime": "Tarih/Saat",
  "DataAccessStringId.ExpressionEditor_FunctionCategory_Logical": "Mantıksal",
  "DataAccessStringId.ExpressionEditor_FunctionCategory_Math": "Matematik",
  "DataAccessStringId.ExpressionEditor_FunctionCategory_Text": "Dize",
  "DataAccessStringId.FileNameFilter_AllFormats": "Tüm desteklenen formatlar",
  "DataAccessStringId.FileNameFilter_CSV": "CSV dosyaları",
  "DataAccessStringId.FileNameFilter_Excel": "Excel çalışma kitapları",
  "DataAccessStringId.FilterByColumnOfMissingTableValidationException": "Filtre dizesi içinde kullanılan sütun [{0}] içeren tablo yok.",
  "DataAccessStringId.IncompleteRelationValidationException": "Belirtilen ilişki eksik: \"{0}\".",
  "DataAccessStringId.LoadingDataPanelText": "... Veri yükleme",
  "DataAccessStringId.LoadingDataSourcePanelCounter": "{0} of {1}...",
  "DataAccessStringId.LoadingDataSourcePanelText": "Veri kaynağı yükleme",
  "DataAccessStringId.LoadingPanelText": "Yükleniyor...",
  "DataAccessStringId.MessageDuplicateItem": "' {0}' Öğe koleksiyonda zaten içeriyor",
  "DataAccessStringId.MessageDuplicateItemName": "Bu koleksiyon zaten ' {0}' adlı bir madde içerir.",
  "DataAccessStringId.MessageDuplicateQueryName": "Belirtilen ada sahip bir sorgu zaten var: {0}.",
  "DataAccessStringId.MessageEmptyQueryName": "Sorgu adı boş olamaz.",
  "DataAccessStringId.MessageInvalidItemName": "Öğe adı null veya boş dize olamaz.",
  "DataAccessStringId.MessageNonexistentQuery": "'{0}' sorgusu yok.",
  "DataAccessStringId.MessageNullItem": "Koleksiyon null bir değere ekleyemezsiniz",
  "DataAccessStringId.MessageWrongCharacterItemName": "Öğe adı ' {0}' yanlış karakterler içeriyor",
  "DataAccessStringId.MessageWrongCharacterParameterName": "Parametre adı '{0}' yanlış karakterler içeriyor",
  "DataAccessStringId.NoTablesValidationException": "Tablolar koleksiyonu boş olamaz.",
  "DataAccessStringId.ODSWizardErrorStaticValue": "Tipi statik ve IEnumerable dönen herhangi bir üye yok.",
  "DataAccessStringId.ParameterListEmpty": "hiçbiri",
  "DataAccessStringId.ParameterListNull": "NULL",
  "DataAccessStringId.ParameterlessConstructor": "varsayılan",
  "DataAccessStringId.PropertyGridBehaviorCategoryName": "Davranış",
  "DataAccessStringId.PropertyGridConnectionCategoryName": "Bağlantı",
  "DataAccessStringId.PropertyGridDataCategoryName": "Veri",
  "DataAccessStringId.PropertyGridDesignCategoryName": "Tasarım",
  "DataAccessStringId.ProviderNotSupportedException": "Aşağıdaki veritabanı sağlayıcısı desteklenmiyor: {0}.",
  "DataAccessStringId.QueriesFailedToValidate_ExceptionMessage": "Bir veya daha fazla sorgu doğrulama başarısız oldu.",
  "DataAccessStringId.QueryBuilderNothingSelected": "Hiçbir sütun seçilmedi. Lütfen devam etmek için en az bir sütun seçin.",
  "DataAccessStringId.QueryBuilder_AllColumns": "* (Tüm sütunlar)",
  "DataAccessStringId.QueryBuilder_AllTables": "(Tüm tablolar)",
  "DataAccessStringId.QueryDesignerJoinExpressionElementSeparator": ",",
  "DataAccessStringId.QueryDesignerJoinExpressionPattern": "{1} üzerindeki {0}",
  "DataAccessStringId.QueryPropertyGridCommonCategoryName": "Ortak",
  "DataAccessStringId.QueryPropertyGridCustomSqlCategoryName": "Özel SQL",
  "DataAccessStringId.QueryPropertyGridTableSelectionCategoryName": "Tablo seçimi",
  "DataAccessStringId.RelationEditorRelationTypeInnerJoin": "İç birleştirmek",
  "DataAccessStringId.RelationEditorRelationTypeLeftOuterJoin": "Sol dış birleştirme",
  "DataAccessStringId.RelationEditorRelationTypeMasterDetail": "Ana ayrıntı ilişkisi",
  "DataAccessStringId.RunExpressionEditor": "İfade Düzenleyicisi...",
  "DataAccessStringId.SqlExecutionException_WithParameters": "parametrelerle:",
  "DataAccessStringId.SqlStringEmptyValidationException": "SQL dizesi null veya boş.",
  "DataAccessStringId.StoredProcParamCountValidationException": "Parametre sayısı uyuşmazlığı: < {0} >, < {1} > bekleniyor.",
  "DataAccessStringId.StoredProcParamNameValidationException": "Parametre adı uyuşmazlığı: < {0} >, < {1} > bekleniyor.",
  "DataAccessStringId.StoredProcParamNullValidationException": "Parametre null olamaz.",
  "DataAccessStringId.StoredProcParamTypeValidationException": "Parametre türü uyuşmazlığı: < {0} >, < {1} > bekleniyor.",
  "DataAccessStringId.Type_Object": "Nesne",
  "DataAccessStringId.UnknownType": "Bilinmeyen",
  "DataAccessStringId.UnnamedColumnValidationException": "Sütun adı belirtilmemiş.",
  "DataAccessStringId.UnnamedTableValidationException": "Tablo adı belirtilmemiş.",
  "DataAccessStringId.WizardCustomConnectionString": "Özel bağlantı dizesi",
  "DataAccessStringId.WizardDataConnectionNameExistsMessage": "Belirtilen veri bağlantı adı zaten var. Lütfen farklı bir bağlantı adı belirtin.",
  "DataAccessStringId.WizardNoEFDataContextsMessage": "Seçili derleme Entity Framework veri bağlamı içermiyor.",
  "DataAccessStringId.XmlFileStrategy_FileNameFilter": "XML dosyaları",
  "DataAccessUIStringId.Button_Add": "&Ekle",
  "DataAccessUIStringId.Button_Apply": "&Uygula",
  "DataAccessUIStringId.Button_Browse": "Gözat",
  "DataAccessUIStringId.Button_Cancel": "&İptal",
  "DataAccessUIStringId.Button_Close": "Kapat",
  "DataAccessUIStringId.Button_Finish": "Bitir",
  "DataAccessUIStringId.Button_Next": "Sonraki",
  "DataAccessUIStringId.Button_OK": "&Tamam",
  "DataAccessUIStringId.Button_Previous": "Önceki",
  "DataAccessUIStringId.Button_Remove": "&Kaldır",
  "DataAccessUIStringId.ConnectionEditorTitle": "Bağlantı Düzenleyicisi",
  "DataAccessUIStringId.ConnectionErrorFormDetailPattern": "Bağlantı adı: {0}\nHata iletisi: {1}",
  "DataAccessUIStringId.ConnectionProperties_AdvantageServerTypeInternet": "Internet",
  "DataAccessUIStringId.ConnectionProperties_AdvantageServerTypeLocal": "Yerel",
  "DataAccessUIStringId.ConnectionProperties_AdvantageServerTypeRemote": "Uzaktan",
  "DataAccessUIStringId.ConnectionProperties_AuthenticationType": "Kimlik doğrulama türü:",
  "DataAccessUIStringId.ConnectionProperties_AuthenticationType_BigQueryOAuth": "OAuth",
  "DataAccessUIStringId.ConnectionProperties_AuthenticationType_MSSqlServer": "Sunucu kimlik doğrulaması",
  "DataAccessUIStringId.ConnectionProperties_AuthenticationType_MSSqlWindows": "Windows kimlik doğrulaması",
  "DataAccessUIStringId.ConnectionProperties_ClientID": "İstemci ID:",
  "DataAccessUIStringId.ConnectionProperties_ConnectionString": "Bağlantı dizesi:",
  "DataAccessUIStringId.ConnectionProperties_Database": "Veritabanı:",
  "DataAccessUIStringId.ConnectionProperties_Encrypt_False": "Hayır",
  "DataAccessUIStringId.ConnectionProperties_Encrypt_True": "Evet",
  "DataAccessUIStringId.ConnectionProperties_Password": "Şifre:",
  "DataAccessUIStringId.ConnectionProperties_Port": "Bağlantı noktası:",
  "DataAccessUIStringId.ConnectionProperties_ProjectID": "Proje ID:",
  "DataAccessUIStringId.ConnectionProperties_Provider": "Sağlayıcı:",
  "DataAccessUIStringId.ConnectionProperties_ServerName": "Sunucu adı:",
  "DataAccessUIStringId.ConnectionProperties_ServerType": "Sunucu ve tipi:",
  "DataAccessUIStringId.ConnectionProperties_ServerTypeEmbedded": "Katıştırılmış",
  "DataAccessUIStringId.ConnectionProperties_ServerTypeServer": "Sunucu",
  "DataAccessUIStringId.ConnectionProperties_SslModeDefault": "Varsayılan",
  "DataAccessUIStringId.ConnectionProperties_SslModeNone": "Hiçbiri",
  "DataAccessUIStringId.ConnectionProperties_TrustServerCertificate_False": "Hayır",
  "DataAccessUIStringId.ConnectionProperties_TrustServerCertificate_True": "Evet",
  "DataAccessUIStringId.ConnectionProperties_UserName": "Kullanıcı adı:",
  "DataAccessUIStringId.DSTypeEF": "Entity Framework",
  "DataAccessUIStringId.DSTypeExcel": "Excel dosyası",
  "DataAccessUIStringId.DSTypeJson": "JSON",
  "DataAccessUIStringId.DSTypeObject": "Nesne",
  "DataAccessUIStringId.DSTypeSql": "Veritabanı",
  "DataAccessUIStringId.DataPreviewForm_Title": "Veri önizleme",
  "DataAccessUIStringId.DataSourceName": "Veri kaynağı adı: {0}",
  "DataAccessUIStringId.EFDataSourceDesignerVerbEdit": "Düzenle...",
  "DataAccessUIStringId.ErrorFormDatasourceInitializationText": "bir veya daha fazla veri kaynakları veri yüklenemiyor. Ayrıntıları aşağıda bkz.",
  "DataAccessUIStringId.ExcelDataSourceDesignerVerbEdit": "Düzenle...",
  "DataAccessUIStringId.ExcelDataSourceDesignerVerbUpdateSchema": "Sonuç şema yeniden",
  "DataAccessUIStringId.ExcelDataSourceWizard_TableItem": "Tablo",
  "DataAccessUIStringId.ExcelDataSourceWizard_Title": "Tablo",
  "DataAccessUIStringId.ExpressionEditorViewTitle": "İfade Düzenleyicisi",
  "DataAccessUIStringId.ExpressionEditor_EmptyExpression": "İfade dizesi boş olamaz.",
  "DataAccessUIStringId.FiltersView": "Filtre Düzenleyicisi",
  "DataAccessUIStringId.FiltersView_Filter": "&Filtre",
  "DataAccessUIStringId.JoinEditorEmptyColumnText": "< sütun seçin >",
  "DataAccessUIStringId.JoinEditorEmptyTableText": "< Tablo >",
  "DataAccessUIStringId.JoinEditorEqualOperator": "Eşittir",
  "DataAccessUIStringId.JoinEditorFillAllFieldsException": "Bazı alanları boş. Lütfen tüm boş alanları doldurun veya devam etmek için ilgili koşulları kaldırın.",
  "DataAccessUIStringId.JoinEditorGreaterOperator": "Büyüktür",
  "DataAccessUIStringId.JoinEditorGreaterOrEqualOperator": "Büyüktür veya eşittir",
  "DataAccessUIStringId.JoinEditorLessOperator": "daha az",
  "DataAccessUIStringId.JoinEditorLessOrEqualOperator": "Küçük veya eşit",
  "DataAccessUIStringId.JoinEditorNotEqualOperator": "eşit değil",
  "DataAccessUIStringId.JsonDataSourceDesignerVerbEdit": "Düzenle...",
  "DataAccessUIStringId.LoadingDataCustomError": "Hata iletisi:\n{0}",
  "DataAccessUIStringId.LoadingDataSourceAborted": "Veri yükleme iptal edildi.",
  "DataAccessUIStringId.LoadingDataSourceOpeningConnectionError": "Bağlantı adı: {0}\nHata iletisi:\n{1}",
  "DataAccessUIStringId.LoadingDataSqlError": "SQL yürütme hatası:\n{0}",
  "DataAccessUIStringId.LoadingDatasourceOutOfMemoryError": "Veri yüklemek için yeterli bellek yok",
  "DataAccessUIStringId.MasterDetailEditorAddConditionMessage": "Yeni koşul oluştur",
  "DataAccessUIStringId.MasterDetailEditorEditRelation": "İlişki Düzenle",
  "DataAccessUIStringId.MasterDetailEditorInvalidQueryNameMessage": "Belirtilen sorgu bulamıyor: \"{0}\". Varolan bir sorgu adı belirtin.",
  "DataAccessUIStringId.MasterDetailEditorRemoveRelationMessage": "İlişkiyi Kaldır",
  "DataAccessUIStringId.MessageBoxConfirmationTitle": "Onay",
  "DataAccessUIStringId.MessageBoxErrorTitle": "Hata",
  "DataAccessUIStringId.MessageBoxWarningTitle": "Uyarı",
  "DataAccessUIStringId.ODSConstructorEditorTitle": "Oluşturucu Ayarlarını Yapılandırma",
  "DataAccessUIStringId.ODSDataMemberEditorTitle": "Veri üyesi yapılandır",
  "DataAccessUIStringId.ODSDataSourceEditorTitle": "Veri kaynağı yapılandır",
  "DataAccessUIStringId.ODSEditorsNoDataSetMessage": "Veri kaynağını belirtilmedikçe geçerli işlem başarılı olamaz.",
  "DataAccessUIStringId.ODSParametersEditorTitle": "Parametreleri Yapılandır",
  "DataAccessUIStringId.ParametersColumn_Expression": "İfade",
  "DataAccessUIStringId.ParametersColumn_Name": "Adı",
  "DataAccessUIStringId.ParametersColumn_QueryName": "Sorgu",
  "DataAccessUIStringId.ParametersColumn_Selected": "Seçili",
  "DataAccessUIStringId.ParametersColumn_Type": "Türü",
  "DataAccessUIStringId.ParametersColumn_Value": "Değer",
  "DataAccessUIStringId.ParametersColumn_Version": "Sürüm",
  "DataAccessUIStringId.PasswordRequest": "Parola",
  "DataAccessUIStringId.PasswordRequest_FileName": "Dosya Adı:",
  "DataAccessUIStringId.PasswordRequest_Password": "&Parola:",
  "DataAccessUIStringId.PasswordRequest_SavePassword": "Parolayı Kaydet",
  "DataAccessUIStringId.QueryBuilder": "Sorgu Oluşturucu",
  "DataAccessUIStringId.QueryBuilderColumn": "Sütun",
  "DataAccessUIStringId.QueryBuilderColumns_Aggregate": "Toplama",
  "DataAccessUIStringId.QueryBuilderColumns_GroupBy": "Göre Gruplandır",
  "DataAccessUIStringId.QueryBuilderColumns_SortOrder": "Sıralama düzeni",
  "DataAccessUIStringId.QueryBuilderCustomSqlRequiresParameters": "Sorgu parametrelerini içerir ve onlar bildirilen önce yürütülemiyor. \nLütfen gerekli sorgu parametreleri bildirmek ve sonuçlar görmek için sonraki Sihirbazı sayfasına gidin.",
  "DataAccessUIStringId.QueryBuilderRelationBetweenTwoColumnsOfTheSameTable": "Aynı tabloya {0} ait iki sütun arasında bir ilişki oluşturamazsınız.",
  "DataAccessUIStringId.QueryBuilderTable": "Tablo",
  "DataAccessUIStringId.QueryBuilder_AddToSelect": "Sorguya Ekle",
  "DataAccessUIStringId.QueryBuilder_Delete": "Sil",
  "DataAccessUIStringId.QueryBuilder_DeleteCondition": "Koşulu Sil",
  "DataAccessUIStringId.QueryBuilder_DeleteRelation": "İlişki Sil",
  "DataAccessUIStringId.QueryBuilder_EditRelation": "İlişki Düzenle",
  "DataAccessUIStringId.QueryBuilder_Rename": "Yeniden adlandırma",
  "DataAccessUIStringId.QueryBuilder_SortAscending": "Artan sıralama",
  "DataAccessUIStringId.QueryBuilder_SortDescending": "Azalan sıralama",
  "DataAccessUIStringId.QueryDesignControlAliasAlreadyExists": "Belirtilen diğer ad zaten. Değeri düzeltmek istiyor musunuz?",
  "DataAccessUIStringId.QueryDesignControlDataPreviewCaption": "Önizleme veri (ilk 1000 satırları görüntülenir)",
  "DataAccessUIStringId.QueryDesignControlExpressionChanged": "Bu eylem SQL ifadesi ve tüm değişiklikleriniz atılacak sıfırlar. Devam etmek istiyor musunuz?",
  "DataAccessUIStringId.QueryDesignControlJoinCommandPattern": "{0} Katılabilir",
  "DataAccessUIStringId.QueryDesignControlNoSelection": "Hiçbir sütun seçilmedi. Lütfen devam etmek için en az bir sütun seçin.",
  "DataAccessUIStringId.QueryDesignControlRemoveTables": "Aşağıdaki tablolarda sorgudan kaldırılır.\n\n{0}\nDevam etmek istiyor musunuz?",
  "DataAccessUIStringId.QueryDesignControlTableNameAlreadyExists": "Bir tablo ile belirtilen ad zaten var. Lütfen farklı bir tablo adı belirtin.",
  "DataAccessUIStringId.QueryDesignControlTableNameEmpty": "Tablo adı boş olamaz.",
  "DataAccessUIStringId.QueryEditorTitle": "Sorgu Düzenleyicisi",
  "DataAccessUIStringId.QueryEditorWaitFormValidating": "Sorgu doğrulanıyor...",
  "DataAccessUIStringId.QueryFilter_BindTo": "Bağla",
  "DataAccessUIStringId.RebuildResultSchemaCaption": "Sonuç şema yeniden",
  "DataAccessUIStringId.SortingTypeAscending": "Artan",
  "DataAccessUIStringId.SortingTypeDescending": "Azalan",
  "DataAccessUIStringId.SortingTypeNone": "Sıralanmamış",
  "DataAccessUIStringId.SqlDataSourceDesignerVerbRebuildSchema": "Şemayı yenile",
  "DataAccessUIStringId.UpdateDBSchemaComplete": "Veritabanı şeması başarıyla güncelleştirildi.",
  "DataAccessUIStringId.WaitFormWithCancel_Loading": "Veri Yükleniyor...",
  "DataAccessUIStringId.WizardCannotConnectMessage": "Veritabanına bağlanamıyor. Aşağıda ayrıntıları bakın.",
  "DataAccessUIStringId.WizardCannotCreateDataSourceMessage": "Boş veri kaynağı oluşturulamıyor. Lütfen dahil etmek için bir nesne seçin.",
  "DataAccessUIStringId.WizardCannotRetrieveDatabasesMessage": "Kullanılabilir veritabanlarının listesini alamıyor. Aşağıda ayrıntıları bakın.",
  "DataAccessUIStringId.WizardDataSourceCreatedMessage": "Veri kaynağındaki verileri başarıyla oluşturuldu",
  "DataAccessUIStringId.WizardDataSourceNameExistsMessage": "< /b > < b > A veri kaynağı belirtilen adla zaten yok",
  "DataAccessUIStringId.WizardFinishPageText": "Veri kaynağınıza dahil etmek için bir nesne seçin",
  "DataAccessUIStringId.WizardPageChooseConnection": "Varolan bir veri bağlantısını kullanmak ister misiniz?",
  "DataAccessUIStringId.WizardPageChooseConnection_ChooseExistingConnection": "Evet, varolan bir bağlantı listesinden seçmeme izin ver",
  "DataAccessUIStringId.WizardPageChooseDSType": "Veri kaynağı türünü seçin.",
  "DataAccessUIStringId.WizardPageChooseDataProvider_SearchPrompt": "Arama",
  "DataAccessUIStringId.WizardPageChooseDataSourceName": "Veri kaynağı adını girin",
  "DataAccessUIStringId.WizardPageChooseEFDataMember": "Veri üyesi seçin",
  "DataAccessUIStringId.WizardPageChooseFile": "Bir Excel çalışma kitabı veya CSV dosyası seçin.",
  "DataAccessUIStringId.WizardPageChooseFileOptions": "Alma ayarlarını belirle.",
  "DataAccessUIStringId.WizardPageChooseFileOptions_DetectAutomatically": "Otomatik olarak algıla",
  "DataAccessUIStringId.WizardPageChooseFileOptions_Encoding": "Kodlama:",
  "DataAccessUIStringId.WizardPageChooseFileOptions_Options": "Seçenekler",
  "DataAccessUIStringId.WizardPageChooseJsonSchema": "Veri alanlarını seçin.",
  "DataAccessUIStringId.WizardPageChooseJsonSchema_FieldName": "Alan Adı",
  "DataAccessUIStringId.WizardPageChooseJsonSchema_Type": "Türü",
  "DataAccessUIStringId.WizardPageChooseMongoDBSchema_FieldName": "Alan Adı",
  "DataAccessUIStringId.WizardPageChooseMongoDBSchema_Type": "Türü",
  "DataAccessUIStringId.WizardPageChooseObjectBindingMode": "Veri bağlama modunu seçin.",
  "DataAccessUIStringId.WizardPageChooseObjectBindingMode_RetrieveSchema": "Veri kaynağı şemasını al",
  "DataAccessUIStringId.WizardPageChooseObjectConstructor": "Bir veri kaynağı Oluşturucu seçin.",
  "DataAccessUIStringId.WizardPageChooseObjectConstructor_ShowOnlyHighlighted": "Yalnızca vurgulanan oluşturucuları göster",
  "DataAccessUIStringId.WizardPageChooseObjectMember_ShowOnlyHighlighted": "Yalnızca vurgulanan üyeleri göster",
  "DataAccessUIStringId.WizardPageChooseObjectType": "Veri kaynağı türünü seçin.",
  "DataAccessUIStringId.WizardPageConfigureEFFilters": "Ekle filtre ölçütü veri için kaynak tablo ve/veya Gösterim.",
  "DataAccessUIStringId.WizardPageConfigureExcelFileColumns": "Gerekli sütunları seçip ayarlarını belirtin.",
  "DataAccessUIStringId.WizardPageConfigureExcelFileColumns_ColumnNameEmptyError": "Sütun adı boş olamaz.",
  "DataAccessUIStringId.WizardPageConfigureJsonConnection_PasswordText": "Şifre:",
  "DataAccessUIStringId.WizardPageConfigureMongoDBConnection_AuthenticationType_None": "Hiçbiri",
  "DataAccessUIStringId.WizardPageConfigureMongoDBQueries_DatabaseNameColumnName": "Veritabanı",
  "DataAccessUIStringId.WizardPageConfigureMongoDBQueries_FilterColumnName": "Filtre",
  "DataAccessUIStringId.WizardPageConfigureParameters": "Sorgu parametrelerini yapılandır ve sonucu önizle.",
  "DataAccessUIStringId.WizardPageConfigureQuery_Query": "Sorgu",
  "DataAccessUIStringId.WizardPageConfigureQuery_StoredProcedure": "Saklı Yordam",
  "DataAccessUIStringId.WizardPageEFConnectionProperties": "Bir bağlantı dizesi belirtin.",
  "DataAccessUIStringId.WizardPageEFConnectionProperties_DefaultConnection": "Varsayılan bağlantı dizesini kullan",
  "DataAccessUIStringId.WizardPageObjectMemberParameters": "Yöntem parametrelerini belirtin.",
  "DataAccessUIStringId.WizardPageSaveConnection": "Bağlantı dizesini kaydedin.",
  "DataAccessUIStringId.WizardPageSaveConnection_SaveConnectionString": "Bağlantı dizesini uygulama yapılandırma dosyasına kaydetmek istiyor musunuz?",
  "DataAccessUIStringId.WizardPageSaveConnection_SaveCredentialsQuestion": "Bağlantı, sunucu kimlik doğrulaması kullanır. \n\nKullanıcı adı ve parolayı proje yapılandırma dosyasına kaydetmek istiyor musunuz?",
  "DataAccessUIStringId.WizardPageSaveConnection_SkipSaveCredentials": "Hayır, Güvenlik sebeplerinden dolayı kimlik atla.",
  "DataAccessUIStringId.WizardTitleDatasource": "Veri kaynağı Sihirbazı",
  "DataAccessWebStringId.QueryBuilder_ColumnsLoading": "Yükleniyor...",
  "DevExpress.Data.ColumnSortOrder.Ascending": "Artan",
  "DevExpress.Data.ColumnSortOrder.Descending": "Azalan",
  "DevExpress.Data.ColumnSortOrder.None": "Hiçbiri",
  "DevExpress.Data.SummaryItemType.Average": "Ortalama",
  "DevExpress.Data.SummaryItemType.Count": "Adet",
  "DevExpress.Data.SummaryItemType.Custom": "Özel",
  "DevExpress.Data.SummaryItemType.Max": "Maksimum",
  "DevExpress.Data.SummaryItemType.Min": "En az",
  "DevExpress.Data.SummaryItemType.None": "Hiçbiri",
  "DevExpress.Data.SummaryItemType.Sum": "Özet",
  "DevExpress.Data.UnboundColumnType.Boolean": "Boole",
  "DevExpress.Data.UnboundColumnType.Bound": "İlişkili",
  "DevExpress.Data.UnboundColumnType.DateTime": "Tarih Saat",
  "DevExpress.Data.UnboundColumnType.Decimal": "Ondalık",
  "DevExpress.Data.UnboundColumnType.Integer": "Tam Sayı",
  "DevExpress.Data.UnboundColumnType.Object": "Nesne",
  "DevExpress.Data.UnboundColumnType.String": "Dize",
  "DevExpress.DataAccess.ConnectionParameters.AsaConnectionParameters.Password": "Şifre",
  "DevExpress.DataAccess.ConnectionParameters.AsaConnectionType.File": "Dosya",
  "DevExpress.DataAccess.ConnectionParameters.FileConnectionParametersBase.Password": "Şifre",
  "DevExpress.DataAccess.ConnectionParameters.FireBirdConnectionParameters.Password": "Şifre",
  "DevExpress.DataAccess.ConnectionParameters.MsSqlAuthorizationType.Windows": "Windows",
  "DevExpress.DataAccess.ConnectionParameters.MySqlSslMode.Default": "Varsayılan",
  "DevExpress.DataAccess.ConnectionParameters.MySqlSslMode.None": "Hiçbiri",
  "DevExpress.DataAccess.ConnectionParameters.OracleConnectionParameters.Password": "Şifre",
  "DevExpress.DataAccess.ConnectionParameters.SqlServerConnectionParametersBase.Password": "Şifre",
  "DevExpress.DataAccess.DataFederation.FederationDataSourceBase.Queries": "Sorgular",
  "DevExpress.DataAccess.DataSourceParameterBase.Name": "Adı",
  "DevExpress.DataAccess.DataSourceParameterBase.Type": "Türü",
  "DevExpress.DataAccess.DataSourceParameterBase.Value": "Değer",
  "DevExpress.DataAccess.EntityFramework.DBSetFilter.Parameters": "Değişkenler",
  "DevExpress.DataAccess.EntityFramework.EFConnectionParameters.ConnectionString": "Bağlantı Dizesi",
  "DevExpress.DataAccess.EntityFramework.EFConnectionParameters.ConnectionStringName": "Bağlantı dizesi adı",
  "DevExpress.DataAccess.EntityFramework.EFConnectionParameters.Source": "Kaynak",
  "DevExpress.DataAccess.EntityFramework.EFDataSource": "EFDataSource",
  "DevExpress.DataAccess.EntityFramework.EFDataSource.Connection": "Bağlantı",
  "DevExpress.DataAccess.EntityFramework.EFDataSource.Filters": "Filtreler",
  "DevExpress.DataAccess.EntityFramework.EFStoredProcedureInfo.Name": "Adı",
  "DevExpress.DataAccess.EntityFramework.EFStoredProcedureInfo.Parameters": "Değişkenler",
  "DevExpress.DataAccess.Excel.CsvSourceOptions.Culture": "Kültür",
  "DevExpress.DataAccess.Excel.CsvSourceOptions.Encoding": "Kodlama",
  "DevExpress.DataAccess.Excel.ExcelDataSource": "Excel Veri Kaynağı",
  "DevExpress.DataAccess.Excel.ExcelDataSource.FileName": "Dosya adı",
  "DevExpress.DataAccess.Excel.ExcelDefinedNameSettings.Scope": "Kapsam",
  "DevExpress.DataAccess.Excel.ExcelSourceOptions.ExcelDefinedNameSettings": "Excel Tanımlı Ad Ayarları",
  "DevExpress.DataAccess.Excel.ExcelSourceOptions.Password": "Şifre",
  "DevExpress.DataAccess.Excel.ExcelSourceOptionsBase.SkipEmptyRows": "Boş Satırları Atla",
  "DevExpress.DataAccess.MongoDB.MongoDBDataSourceBase.Queries": "Sorgular",
  "DevExpress.DataAccess.MongoDB.MongoDBQuery.Parameters": "Değişkenler",
  "DevExpress.DataAccess.ObjectBinding.ObjectDataSource.Constructor": "Oluşturucu",
  "DevExpress.DataAccess.ObjectBinding.ObjectDataSource.DataMember": "Veri Öğesi",
  "DevExpress.DataAccess.ObjectBinding.ObjectDataSource.DataSource": "Veri Kaynağı",
  "DevExpress.DataAccess.ObjectBinding.ObjectDataSource.Parameters": "Değişkenler",
  "DevExpress.DataAccess.Parameter.Name": "Adı",
  "DevExpress.DataAccess.Parameter.Type": "Türü",
  "DevExpress.DataAccess.Parameter.Value": "Değer",
  "DevExpress.DataAccess.Sql.CustomSqlQuery.Sql": "SQL",
  "DevExpress.DataAccess.Sql.ObjectDataSource": "ObjectDataSource",
  "DevExpress.DataAccess.Sql.SelectQuery.Distinct": "Farklı",
  "DevExpress.DataAccess.Sql.SelectQuery.Skip": "Atla",
  "DevExpress.DataAccess.Sql.SelectQuery.Top": "Üst",
  "DevExpress.DataAccess.Sql.SqlDataSource": "SqlDataSource",
  "DevExpress.DataAccess.Sql.SqlDataSource.ConnectionName": "Bağlantı Adı",
  "DevExpress.DataAccess.Sql.SqlDataSource.ConnectionParameters": "Bağlantı Parametreleri",
  "DevExpress.DataAccess.Sql.SqlDataSource.Queries": "Sorgular",
  "DevExpress.DataAccess.Sql.SqlDataSource.Relations": "İlişkiler",
  "DevExpress.DataAccess.Sql.SqlIsolationLevel.None": "Hiçbiri",
  "DevExpress.DataAccess.Sql.SqlQuery.Name": "Adı",
  "DevExpress.DataAccess.Sql.SqlQuery.Parameters": "Değişkenler",
  "DevExpress.DataAccess.Sql.TableQuery.FilterString": "Filtre dizesi",
  "DevExpress.DataAccess.Sql.TableQuery.GroupFilterString": "Grup filtre dizesi",
  "DevExpress.DataAccess.Sql.TableQuery.Skip": "Atla",
  "DevExpress.DataAccess.Sql.TableQuery.Top": "Üst",
  "DevExpress.Snap.Core.Fields.UpdateMergeImageFieldMode.KeepScale": "Ölçeği Koru",
  "DevExpress.Snap.Core.Fields.UpdateMergeImageFieldMode.KeepSize": "Boyutu Koru",
  "DevExpress.Snap.Core.Native.SNSortOrder.Ascending": "Artan",
  "DevExpress.Snap.Core.Native.SNSortOrder.Descending": "Azalan",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.BarCode": "Barkod",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.CheckBox": "Onay kutusu",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.Hyperlink": "Köprü",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.Image": "Görüntü",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.Index": "Dizin",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.Sparkline": "Mini grafik",
  "DevExpress.Snap.Extensions.Native.ActionLists.ContentType.Text": "Metin",
  "DevExpress.Snap.Extensions.Native.ActionLists.SnapCheckState.Checked": "İşaretli",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.DOC": "DOC",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.HTML": "HTML",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.MHT": "MHT",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.OpenDocument": "OpenDocument",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.OpenXML": "OpenXML",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.PlainText": "Düz Metin",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.RTF": "RTF",
  "DevExpress.Snap.Extensions.Native.ActionLists.TextFormat.WordML": "WordML",
  "DevExpress.Sparkline.SparklineViewType.Area": "Alan",
  "DevExpress.Sparkline.SparklineViewType.Bar": "Çubuk",
  "DevExpress.Sparkline.SparklineViewType.Line": "Çizgi",
  "DevExpress.Sparkline.SparklineViewType.WinLoss": "WinLoss",
  "DevExpress.Utils.DefaultBoolean.Default": "Varsayılan",
  "DevExpress.Utils.DefaultBoolean.False": "Hayır",
  "DevExpress.Utils.DefaultBoolean.True": "Evet",
  "DevExpress.Utils.FormatInfo.FormatString": "Biçimlendirme Kalıbı",
  "DevExpress.Utils.FormatInfo.FormatType": "Biçimlendirme Tipi",
  "DevExpress.Utils.FormatType.Custom": "Kişisel",
  "DevExpress.Utils.FormatType.DateTime": "Tarih Saat",
  "DevExpress.Utils.FormatType.None": "Hiçbiri",
  "DevExpress.Utils.FormatType.Numeric": "Rakamsal",
  "DevExpress.Utils.HorzAlignment.Center": "Orta",
  "DevExpress.Utils.HorzAlignment.Default": "Varsayılan",
  "DevExpress.Utils.HorzAlignment.Far": "Uzak",
  "DevExpress.Utils.HorzAlignment.Near": "Yakın",
  "DevExpress.Utils.OptionsColumnLayout.AddNewColumns": "Yeni Sütunlar Ekle",
  "DevExpress.Utils.OptionsColumnLayout.RemoveOldColumns": "Eksi Sütunları Çıkar",
  "DevExpress.Utils.OptionsColumnLayout.StoreAllOptions": "Bütün Seçenekleri Sakla",
  "DevExpress.Utils.OptionsColumnLayout.StoreAppearance": "Görünümü Sakla",
  "DevExpress.Utils.OptionsColumnLayout.StoreLayout": "Yerleşimi Sakla",
  "DevExpress.Utils.Svg.SvgImage.Height": "Yükseklik",
  "DevExpress.Utils.Svg.SvgImage.Width": "Genişlik",
  "DevExpress.Utils.VertAlignment.Bottom": "Alt",
  "DevExpress.Utils.VertAlignment.Center": "Orta",
  "DevExpress.Utils.VertAlignment.Default": "Varsayılan",
  "DevExpress.Utils.VertAlignment.Top": "Üst",
  "DevExpress.Utils.WordWrap.Default": "Varsayılan",
  "DevExpress.Utils.WordWrap.NoWrap": "Kaydırma yok",
  "DevExpress.Utils.WordWrap.Wrap": "Şal",
  "DevExpress.Xpo.XPObjectSource.FilterString": "Filtre",
  "DevExpress.Xpo.XPObjectSource.Parameters": "Değişkenler",
  "DevExpress.Xpo.XPObjectSource.Properties": "Özellikler",
  "DevExpress.Xpo.XPObjectSource.Tag": "Etiket",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Auto": "Oto",
  "DevExpress.XtraPrinting.BorderDashStyle.Dash": "Tire",
  "DevExpress.XtraPrinting.BorderDashStyle.DashDot": "Tire-Nokta",
  "DevExpress.XtraPrinting.BorderDashStyle.DashDotDot": "Tire-Nokta-Nokta",
  "DevExpress.XtraPrinting.BorderDashStyle.Dot": "Nokta",
  "DevExpress.XtraPrinting.BorderDashStyle.Double": "Çift",
  "DevExpress.XtraPrinting.BorderDashStyle.Solid": "Düz",
  "DevExpress.XtraPrinting.BorderSide.All": "Hepsi",
  "DevExpress.XtraPrinting.BorderSide.Bottom": "Alt",
  "DevExpress.XtraPrinting.BorderSide.Left": "Sol",
  "DevExpress.XtraPrinting.BorderSide.None": "Hiçbiri",
  "DevExpress.XtraPrinting.BorderSide.Right": "Sağ",
  "DevExpress.XtraPrinting.BorderSide.Top": "Üst",
  "DevExpress.XtraPrinting.CheckBoxState.Checked": "İşaretli",
  "DevExpress.XtraPrinting.HorizontalContentSplitting.Exact": "Tam",
  "DevExpress.XtraPrinting.HorizontalContentSplitting.Smart": "Akıllı",
  "DevExpress.XtraPrinting.ImageAlignment.Default": "Varsayılan",
  "DevExpress.XtraPrinting.ImageSizeMode.AutoSize": "Oto-Boyutlandırma",
  "DevExpress.XtraPrinting.ImageSizeMode.CenterImage": "Resmi Ortala",
  "DevExpress.XtraPrinting.ImageSizeMode.Normal": "Normal",
  "DevExpress.XtraPrinting.ImageSizeMode.Squeeze": "Sıkıştır",
  "DevExpress.XtraPrinting.ImageSizeMode.StretchImage": "Resmi Uzat",
  "DevExpress.XtraPrinting.ImageSizeMode.ZoomImage": "Resme Yakınlaş",
  "DevExpress.XtraPrinting.PaddingInfo.All": "Hepsi",
  "DevExpress.XtraPrinting.PaddingInfo.Bottom": "Alt",
  "DevExpress.XtraPrinting.PaddingInfo.Left": "Sol",
  "DevExpress.XtraPrinting.PaddingInfo.Right": "Sağ",
  "DevExpress.XtraPrinting.PaddingInfo.Top": "Üst",
  "DevExpress.XtraPrinting.PageInfo.DateTime": "Şimdinin Tarih ve Saati",
  "DevExpress.XtraPrinting.PageInfo.None": "Hiçbiri",
  "DevExpress.XtraPrinting.PageInfo.Number": "Sayfa Numarası",
  "DevExpress.XtraPrinting.PageInfo.NumberOfTotal": "\"Geçerli Sayfa/Hepsi\" Sayfa Numarası",
  "DevExpress.XtraPrinting.PageInfo.RomHiNumber": "Sayfa Numarası(Roma Rakamı, Büyük Harf)",
  "DevExpress.XtraPrinting.PageInfo.RomLowNumber": "Sayfa Numarası(Roma Rakamı, Küçük Harf)",
  "DevExpress.XtraPrinting.PageInfo.Total": "Sayfa Sayısı",
  "DevExpress.XtraPrinting.PageInfo.UserName": "Kullanıcı Adı",
  "DevExpress.XtraPrinting.PdfExportOptions.DefaultResourceFile": "Varsayılan Kaynak Dosyası",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.PdfPermissionsOptions": "PdfİzinSeçenekleri",
  "DevExpress.XtraPrinting.PrinterSettingsUsing.UseMargins": "Kenar Boşlukları Kullanımı",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Background": "Arkaplan",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ClosePreview": "Doküman Önizlemeyi Kapat",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Copy": "Kopyala",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Customize": "Kişiselleştir",
  "DevExpress.XtraPrinting.PrintingSystemCommand.DocumentMap": "Doküman Haritası",
  "DevExpress.XtraPrinting.PrintingSystemCommand.EditPageHF": "Sayfayı Düzenle H F",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportCsv": "CSV Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportDocx": "DOCX verme",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportFile": "Dosyayı Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportGraphic": " Resim Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportHtm": "HTML Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportMht": "MHT Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportPdf": "PDF Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportRtf": "RTF Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportTxt": "TXT Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportXls": "XLS Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportXlsx": "XLSX Olarak Aktar",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ExportXps": "XPS",
  "DevExpress.XtraPrinting.PrintingSystemCommand.File": "Dosya",
  "DevExpress.XtraPrinting.PrintingSystemCommand.FillBackground": "Arkaplanı Doldur",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Find": "Ara",
  "DevExpress.XtraPrinting.PrintingSystemCommand.GoToPage": "Sayfaya Git",
  "DevExpress.XtraPrinting.PrintingSystemCommand.HandTool": "El Aracı",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Magnifier": "Büyüteç",
  "DevExpress.XtraPrinting.PrintingSystemCommand.MultiplePages": "Çoklu Sayfa",
  "DevExpress.XtraPrinting.PrintingSystemCommand.None": "Hiçbiri",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Open": "Aç",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PageLayout": "Sayfa Yerleşimi",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PageLayoutContinuous": "Sayfa Yerleşimi - Sürekli",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PageLayoutFacing": "Sayfa Yerleşimi - Karşıdan",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PageMargins": "Sayfa Kenar Boşlukları",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PageOrientation": "Sayfa Yönü",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PageSetup": "Sayfa Düzeni",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PaperSize": "Kağıt Boyu",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Parameters": "Değişkenler",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Pointer": "İmleç",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Print": "Yazdır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PrintDirect": "Doğrudan Yazdır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.PrintSelection": "Seçimi Yazdır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Save": "Kaydet",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Scale": "Ölçeklendir",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ScrollPageDown": "Sayfayı Aşağı Kaydır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ScrollPageUp": "Sayfayı Yukarı Kaydır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendCsv": "CSV Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendFile": "Dosya Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendGraphic": "Resim Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendMht": "MHT Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendPdf": "PDF Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendRtf": "RTF Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendTxt": "TXT Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendXls": "XLS Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendXlsx": "XLSX Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SendXps": "XPS Olarak Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ShowFirstPage": "İlk Sayfayı Göster",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ShowLastPage": "Son Sayfayı Göster",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ShowNextPage": "Sonraki Sayfayı Göster",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ShowPrevPage": "Önceki Sayfayı Göster",
  "DevExpress.XtraPrinting.PrintingSystemCommand.StopPageBuilding": "Sayfa Oluşturmayı Durdur",
  "DevExpress.XtraPrinting.PrintingSystemCommand.SubmitParameters": "Değişkenleri Gönder",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Thumbnails": "Küçük resimler",
  "DevExpress.XtraPrinting.PrintingSystemCommand.View": "Görünüm",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ViewWholePage": "Tüm Sayfayı Göster",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Watermark": "Filigran",
  "DevExpress.XtraPrinting.PrintingSystemCommand.Zoom": "Yakınlaştırma",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomIn": "Yakınlaştır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomOut": "Uzaklaştır",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomToPageWidth": "Sayfa Genişliğine Ayarla",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomToTextWidth": "Metin Genişliğine Ayarla",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomToTwoPages": "İki Sayfaya Ayarla",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomToWholePage": "Tüm Sayfaya Ayarla",
  "DevExpress.XtraPrinting.PrintingSystemCommand.ZoomTrackBar": "Yakınlaştırma Takip Çubuğu",
  "DevExpress.XtraPrinting.TextAlignment.BottomCenter": "Alt Orta",
  "DevExpress.XtraPrinting.TextAlignment.BottomJustify": "Alt İki Yana Yasla",
  "DevExpress.XtraPrinting.TextAlignment.BottomLeft": "Alt Sol",
  "DevExpress.XtraPrinting.TextAlignment.BottomRight": "Alt Sağ",
  "DevExpress.XtraPrinting.TextAlignment.MiddleCenter": "Orta Orta",
  "DevExpress.XtraPrinting.TextAlignment.MiddleJustify": "Orta İki Yana Yasla",
  "DevExpress.XtraPrinting.TextAlignment.MiddleLeft": "Orta Sol",
  "DevExpress.XtraPrinting.TextAlignment.MiddleRight": "Orta Sağ",
  "DevExpress.XtraPrinting.TextAlignment.TopCenter": "Üst Orta",
  "DevExpress.XtraPrinting.TextAlignment.TopJustify": "Üst İki Yana Yasla",
  "DevExpress.XtraPrinting.TextAlignment.TopLeft": "Üst Sol",
  "DevExpress.XtraPrinting.TextAlignment.TopRight": "Üst Sağ",
  "DevExpress.XtraPrinting.VerticalContentSplitting.Exact": "Tam",
  "DevExpress.XtraPrinting.VerticalContentSplitting.Smart": "Zeki",
  "DevExpress.XtraPrinting.XlsExportOptions.Ignore256ColumnsLimit": "256 Sütun Limitini Gözardı Et",
  "DevExpress.XtraPrinting.XlsExportOptions.Ignore65536RowsLimit": "65536 Satır Limitini Gözardı Et",
  "DevExpress.XtraPrinting.XlsExportOptions.UseNativeFormat": "Native Formatı Kullan",
  "DevExpress.XtraReports.UI.FieldType.Boolean": "Mantıksal",
  "DevExpress.XtraReports.UI.FieldType.Byte": "Bayt",
  "DevExpress.XtraReports.UI.FieldType.DateTime": "DateTime",
  "DevExpress.XtraReports.UI.FieldType.Decimal": "Decimal",
  "DevExpress.XtraReports.UI.FieldType.Double": "Çift",
  "DevExpress.XtraReports.UI.FieldType.Float": "Gezici",
  "DevExpress.XtraReports.UI.FieldType.Guid": "GUID",
  "DevExpress.XtraReports.UI.FieldType.Int16": "Int16",
  "DevExpress.XtraReports.UI.FieldType.Int32": "Int32",
  "DevExpress.XtraReports.UI.FieldType.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.FieldType.String": "Dize",
  "DevExpress.XtraReports.UI.FieldType.TimeSpan": "ZamanSüreci",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.Boolean": "Boolean",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.Bound": "Bağlı",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.DateTime": "Tarih/Saat",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.Decimal": "Ondalık",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.Integer": "Tamsayı",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.Object": "Nesne",
  "DevExpress.XtraTreeList.Data.UnboundColumnType.String": "Dize",
  "DxDesignerStringId.CodeCompletion_Field": "alan",
  "DxDesignerStringId.CodeCompletion_List": "liste",
  "DxDesignerStringId.CodeCompletion_Operator": "operatör",
  "DxDesignerStringId.None": "(Yok)",
  "ExpressionEditorStringId.Constant_False": "Mantıksal False değerini gösterir.",
  "ExpressionEditorStringId.Constant_Null": "Bir nesneye işaret etmeyen null referansı temsil eder.",
  "ExpressionEditorStringId.Constant_True": "Mantıksal True değerini temsil eder.",
  "ExpressionEditorStringId.Function_Abs": "Abs(Value)\nBelirtilen sayısal ifade mutlak, pozitif değeri verir.",
  "ExpressionEditorStringId.Function_Acos": "Acos(Value)\n(Açı, radyan kosinüsüdür belirtilen float ifade) bir sayının arkkosinüsünü verir.",
  "ExpressionEditorStringId.Function_AddDays": "AddDays(TarihZaman, GunSayisi)\nBelirtilen TarihZaman'dan belirtilen GunSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddHours": "AddHours(TarihZaman, SaatSayisi)\nBelirtilen TarihZaman'dan belirtilen SaatSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddMilliSeconds": "AddMilliSeconds(TarihZaman, MSSayisi)\nBelirtilen TarihZaman'dan belirtilen MSSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddMinutes": "AddMinutes(TarihZaman, DakikaSayisi)\nBelirtilen TarihZaman'dan belirtilen DakikaSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddMonths": "AddMonths(TarihZaman, AySayisi)\nBelirtilen TarihZaman'dan belirtilen AySayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddSeconds": "AddSeconds(TarihZaman, SaniyeSayisi)\nBelirtilen TarihZaman'dan belirtilen SaniyeSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddTicks": "AddTicks(TarihZaman, AnSayisi)\nBelirtilen TarihZaman'dan belirtilen AnSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddTimeSpan": "AddTimeSpan(TarihZaman, ZamanAralik)\nBelirtilen TarihZaman'dan belirtilen ZamanAraliki kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_AddYears": "AddYears(TarihZaman, YilSayisi)\nBelirtilen TarihZaman'dan belirtilen YilSayisi kadar sonrasının tarihini döner.",
  "ExpressionEditorStringId.Function_Ascii": "Ascii(String)\nBir karakter ifadesindeki en soldaki karakterin ASCII değerini döner.",
  "ExpressionEditorStringId.Function_Asin": "Asin(Value)\n(Açı, radyan sinüsü belirtilen float ifade olduğunu) bir sayının arksinüsünü verir.",
  "ExpressionEditorStringId.Function_Atn": "Atn(Value)\n(Açı, radyan tanjantı belirtilen float ifade) bir sayının arktanjantını verir.",
  "ExpressionEditorStringId.Function_Atn2": "Atn2 (Değer1, değer2)\nTanjantı iki belirtilen sayının radyan cinsinden açı verir.",
  "ExpressionEditorStringId.Function_AvgAggregate": "Avg(Value)\nKoleksiyondaki değerlerini değerlendirir.",
  "ExpressionEditorStringId.Function_BigMul": "BigMul(Değer1, Değer2)\nBelirtilen 2 32-bit değerin tam çarpımını Int64 olarak döner.",
  "ExpressionEditorStringId.Function_Ceiling": "Ceiling(Value)\nBüyük veya eşit belirtilen sayısal ifade en küçük tamsayıyı döndürür.",
  "ExpressionEditorStringId.Function_Char": "Char(Number)\nBir integerASCIICode bir karaktere dönüştürür.",
  "ExpressionEditorStringId.Function_CharIndex": "CharIndex(dize1, dize2)\nSıfır karakter konumu bir dize sonu başlayan Dize1 Dize2, içindeki başlangıç konumunu döndürür.",
  "ExpressionEditorStringId.Function_CharIndex_3": "CharIndex(dize1, dize2, StartLocation)\nStartLocation karakter konumu bir dize sonu başlayan Dize1 Dize2, içindeki başlangıç konumunu döndürür.",
  "ExpressionEditorStringId.Function_Concat": "Concat (String1,..., StringN)\nHerhangi bir ek dizeler geçerli dize birleştirme içeren bir string değeri döndürür.",
  "ExpressionEditorStringId.Function_Contains": "Contains(String, SubString)\nEğer SubString, String içerisinde varsa True döner. Yoksa False döner.",
  "ExpressionEditorStringId.Function_Cos": "Cos(Value)\nRadyan cinsinden tanımlanan açının kosinüsünü verir.",
  "ExpressionEditorStringId.Function_Cosh": "Cosh(Value)\nRadyan cinsinden tanımlanan açının hiperbolik kosinüsünü verir.",
  "ExpressionEditorStringId.Function_CountAggregate": "Count() işlevi\nBir koleksiyon nesne sayısını döndürür.",
  "ExpressionEditorStringId.Function_DateDiffDay": "DateDiffDay(basTarih, sonTarih)\nİki null olmayan tarih arasındaki gün farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffHour": "DateDiffHour(basTarih, sonTarih)\nİki null olmayan tarih arasındaki saat farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffMilliSecond": "DateDiffMilliSecond(basTarih, sonTarih)\nİki null olmayan tarih arasındaki milisaniye farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffMinute": "DateDiffMinute(basTarih, sonTarih)\nİki null olmayan tarih arasındaki dakika farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffMonth": "DateDiffMonth(basTarih, sonTarih)\nİki null olmayan tarih arasındaki ay farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffSecond": "DateDiffSecond(basTarih, sonTarih)\nİki null olmayan tarih arasındaki saniye farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffTick": "DateDiffTick(basTarih, sonTarih)\nİki null olmayan tarih arasındaki an farkını döner.",
  "ExpressionEditorStringId.Function_DateDiffYear": "DateDiffYear(basTarih, sonTarih)\nİki null olmayan tarih arasındaki yıl farkını döner.",
  "ExpressionEditorStringId.Function_EndsWith": "EndsWith(String, SonString)\nEğer SonString, String'in sonunda yer alıyorsa True döner. Yoksa False döner.",
  "ExpressionEditorStringId.Function_ExistsAggregate": "Exists()\nNesne koleksiyonda zaten var olup olmadığını belirler.",
  "ExpressionEditorStringId.Function_Exp": "Exp(Value)\nBelirtilen float ifade üstel değerini verir.",
  "ExpressionEditorStringId.Function_Floor": "Floor(Value)\nEn büyük tamsayıyı döndürür belirtilen sayısal ifade küçük veya eşit.",
  "ExpressionEditorStringId.Function_GetDate": "GetDate(TarihZaman)\nVerilen TarihZaman'dan Tarih alır",
  "ExpressionEditorStringId.Function_GetDay": "GetDay(TarihZaman)\nVerilen TarihZaman'dan Gün alır",
  "ExpressionEditorStringId.Function_GetDayOfWeek": "GetDayOfWeek(TarihZaman)\nVerilen TarihZaman'dan haftanın gününü alır",
  "ExpressionEditorStringId.Function_GetDayOfYear": "GetDayOfYear(TarihZaman)\nVerilen TarihZaman'dan yılın gününü alır",
  "ExpressionEditorStringId.Function_GetHour": "GetHour(TarihZaman)\nVerilen TarihZaman'dan saati alır.",
  "ExpressionEditorStringId.Function_GetMilliSecond": "GetMilliSecond(TarihZaman)\nVerilen TarihZaman'dan milisaniyeyi alır.",
  "ExpressionEditorStringId.Function_GetMinute": "GetMinute(TarihZaman)\nVerilen TarihZaman'dan dakikayı alır.",
  "ExpressionEditorStringId.Function_GetMonth": "GetMonth(TarihZaman)\nVerilen TarihZaman'dan ayı alır.",
  "ExpressionEditorStringId.Function_GetSecond": "GetSecond(TarihZaman)\nVerilen TarihZaman'dan saniyeyi alır.",
  "ExpressionEditorStringId.Function_GetTimeOfDay": "GetTimeOfDay(TarihZaman)\nVerilen TarihZaman'dan an olarak günün zamanını alır.",
  "ExpressionEditorStringId.Function_GetYear": "GetYear(TarihZaman)\nVerilen TarihZaman'dan yılı alır.",
  "ExpressionEditorStringId.Function_Iif": "Iif(Ifade, DogruKesim, YanlisKesim)\nEğer Ifade'nin mantıksal sonucu true ise DogruKesim'i, false ise YanlisKesim'i döner.",
  "ExpressionEditorStringId.Function_Insert": "Insert(String1, İlkPoizsyon, String2)\nString2'yi String1'in İlkPoizsyon'una ekler.",
  "ExpressionEditorStringId.Function_IsNull": "IsNull(Değer)\nVerilen değer NULL ise True döner.",
  "ExpressionEditorStringId.Function_IsNullOrEmpty": "IsNullOrEmpty(String)\nVerilen String NULL veya boş bir string ise True döner. Değilse False döner",
  "ExpressionEditorStringId.Function_IsThisMonth": "IsThisMonth(TarihZaman)\nVerilen TarihZaman bu ay içerisindeyse True döner.",
  "ExpressionEditorStringId.Function_IsThisWeek": "IsThisWeek(TarihZaman)\nVerilen TarihZaman bu hafta içerisindeyse True döner.",
  "ExpressionEditorStringId.Function_IsThisYear": "IsThisYear(TarihZaman)\nVerilen TarihZaman bu yıl içerisindeyse True döner.",
  "ExpressionEditorStringId.Function_Len": "Len(Value)\nBir dize ya da nominal bir değişkeni depolamak için gereken bayt sayısını da içeren bir tamsayı karakter sayısını verir.",
  "ExpressionEditorStringId.Function_LocalDateTimeDayAfterTomorrow": "LocalDateTimeDayAfterTomorrow()\nErtesi gün için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeLastWeek": "LocalDateTimeLastWeek()\nÖnceki haftanın ilk günü için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeNextMonth": "LocalDateTimeNextMonth()\nBir sonraki ayın ilk günü için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeNextWeek": "LocalDateTimeNextWeek()\nAşağıdaki haftanın ilk günü için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeNextYear": "LocalDateTimeNextYear()\nErtesi yıl ilk günü için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeNow": "LocalDateTimeNow()\nZaman şimdiki an ilgili tarih ve saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeThisMonth": "LocalDateTimeThisMonth()\nGeçerli ayın ilk günü için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeThisWeek": "LocalDateTimeThisWeek()\nGeçerli haftanın ilk gününe ilgili tarih ve saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeThisYear": "LocalDateTimeThisYear()\nGeçerli yılın ilk günü için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeToday": "LocalDateTimeToday()\nBugün için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeTomorrow": "LocalDateTimeTomorrow()\nYarın için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeTwoWeeksAway": "LocalDateTimeTwoWeeksAway()\nSonra gelecek hafta haftanın ilk günü ilgili tarih ve saat değeri döndürür.",
  "ExpressionEditorStringId.Function_LocalDateTimeYesterday": "LocalDateTimeYesterday()\nDün için karşılık gelen bir tarih saat değeri döndürür.",
  "ExpressionEditorStringId.Function_Log": "Log(Value)\nBelirtilen sayının doğal logaritmasını döndürür.",
  "ExpressionEditorStringId.Function_Log10": "Log10(Değer)\nVerilen Değer'in 10 tabanında logaritmasını döner.",
  "ExpressionEditorStringId.Function_Log_2": "Log(Değer, Taban)\nVerilen Değer'in Taban tabanında logaritmasını döner.",
  "ExpressionEditorStringId.Function_Lower": "Lower(String)\nHarflerle dizesini döndürür.",
  "ExpressionEditorStringId.Function_Max": "Max (Değer1, değer2)\nEn büyük değer belirtilen değerleri döndürür.",
  "ExpressionEditorStringId.Function_MaxAggregate": "Max(Value)\nMaksimum ifade değeri bir koleksiyon döndürür.",
  "ExpressionEditorStringId.Function_Min": "Min (Değer1, değer2)\nEn düşük değer belirtilen değerleri döndürür.",
  "ExpressionEditorStringId.Function_MinAggregate": "Min(Value)\nMinimum ifade değeri bir koleksiyon döndürür.",
  "ExpressionEditorStringId.Function_NewLine": "NewLine()\n\nBu ortam için tanımlanan yeni satır dize döndürür.",
  "ExpressionEditorStringId.Function_Now": "Now()\nŞu anın sistem tarih ve zamanını döner.",
  "ExpressionEditorStringId.Function_PadLeft": "PadLeft (dize, uzunluk)\nSol tarafında bir belirtilen toplam uzunluğu kadar beyaz boşluk karakterleri ile doldurma tanımlanmış dizedeki karakter kümelerini sola hizalar.",
  "ExpressionEditorStringId.Function_PadLeft_3": "PadLeft(String, uzunluk, Char)\nSol tarafında bir belirtilen toplam uzunluk belirtilen Char ile doldurma tanımlanmış dizedeki karakter kümelerini sola hizalar.",
  "ExpressionEditorStringId.Function_PadRight": "PadRight (dize, uzunluk)\nSol tarafında bir belirtilen toplam uzunluğu kadar beyaz boşluk karakterleri ile doldurma tanımlanmış dizedeki karakter kümelerini sağa hizalar.",
  "ExpressionEditorStringId.Function_PadRight_3": "PadRight(String, uzunluk, Char)\nSol tarafında bir belirtilen toplam uzunluk belirtilen Char ile doldurma tanımlanmış dizedeki karakter kümelerini sağa hizalar.",
  "ExpressionEditorStringId.Function_Power": "Power (güç, değeri)\nBelirtilen üssü belirtilen bir sayı verir.",
  "ExpressionEditorStringId.Function_Remove": "Kaldır(dize, StartPosition)\nBu örnek, belirtilen konumda başlayan tüm karakterleri siler.",
  "ExpressionEditorStringId.Function_Remove_3": "Remove(String, BasPozisyon, Uzunluk)\nVerilen String'in BasPozisyon'undan başlayarak Uzunluk kadar karakter siler.",
  "ExpressionEditorStringId.Function_Replace": "Replace(String, AltString2, String3)\nString'in içerisinde geçen AltString2'leri String3 ile değiştirir ve bu kopyayı döner.",
  "ExpressionEditorStringId.Function_Reverse": "Reverse(String)\nBir dize içinde öğelerin sırası tersine çevirir.",
  "ExpressionEditorStringId.Function_Rnd": "Rnd()\n1'den, ama sıfırdan büyük veya sıfıra eşit olan rasgele bir sayı verir.",
  "ExpressionEditorStringId.Function_Round": "Round(Value)\nVerilen değer en yakın tam sayıya yuvarlar.",
  "ExpressionEditorStringId.Function_Round_2": "Yuvarla(Değer, Hassasiyet)\nVerilen Değer'i en yakın tam sayıya veya verilen Hassasiyet kadar ondalık içeren sayıya yuvarlar.",
  "ExpressionEditorStringId.Function_Sign": "Sign(Value)\nPozitif (+ 1), sıfır (0) veya negatif (-1) verilen ifade işareti döndürür.",
  "ExpressionEditorStringId.Function_Sin": "Sin(Value)\nRadyan cinsinden tanımlanan açının sinüsünü verir.",
  "ExpressionEditorStringId.Function_SingleAggregate": "Single()\nTek bir nesne derlemeden döndürür.",
  "ExpressionEditorStringId.Function_Sinh": "Sinh(Value)\nRadyan cinsinden tanımlanan açının hiperbolik sinüsünü verir.",
  "ExpressionEditorStringId.Function_Sqr": "Sqr(Value)\nVerilen bir sayının kare kökünü verir.",
  "ExpressionEditorStringId.Function_StartsWith": "StartsWith (dize, StartString)\nDoğru dize başlangıcı StartString uyup uymadığını verir; Aksi takdirde, False döndürülür.",
  "ExpressionEditorStringId.Function_Substring": "Substring(String, BasPozisyon)\nStrin'ten bir alt string döner. Alt string, BasPozisyon'dan başlar.",
  "ExpressionEditorStringId.Function_Substring_3": "Substring(String, BasPozisyon, Uzunluk)\nStrin'ten bir alt string döner. Alt string, BasPozisyon'dan başlar ve verilen Uzunluk kadar karakter içerir.",
  "ExpressionEditorStringId.Function_SumAggregate": "Sum(Value)\nTüm ifade değerleri koleksiyonunda verir.",
  "ExpressionEditorStringId.Function_Tan": "Tan(Value)\nRadyan cinsinden tanımlanan açının tanjantını verir.",
  "ExpressionEditorStringId.Function_Tanh": "Tanh(Value)\nRadyan cinsinden tanımlanan açının hiperbolik tanjantını verir.",
  "ExpressionEditorStringId.Function_ToDecimal": "ToDecimal(Value)\nEşdeğer bir ondalık sayıya dönüştürür değer.",
  "ExpressionEditorStringId.Function_ToDouble": "ToDouble(Value)\nBir eşdeğer 64-bit çift duyarlıklı kayan nokta sayısı için değer dönüştürür.",
  "ExpressionEditorStringId.Function_ToFloat": "ToFloat(Value)\nBir eşdeğer 32 bitlik tek duyarlıklı kayan nokta sayısı için değer dönüştürür.",
  "ExpressionEditorStringId.Function_ToInt": "ToInt(Value)\nEşdeğer bir 32 bitlik imzalı tamsayı değeri dönüştürür.",
  "ExpressionEditorStringId.Function_ToLong": "ToLong(Value)\nEşdeğer bir 64 bitlik imzalı tamsayı değeri dönüştürür.",
  "ExpressionEditorStringId.Function_ToStr": "ToStr(Value)\nNesne bir dize gösterimini verir.",
  "ExpressionEditorStringId.Function_Today": "Today()\nBugünün tarihini döner. İsimden bağımsız olarak bugünün geceyarısını döner.",
  "ExpressionEditorStringId.Function_Trim": "Trim(String)\nTüm baştaki ve sondaki boşluk karakterleri dizesi kaldırır.",
  "ExpressionEditorStringId.Function_Upper": "Upper(String)\nBüyük harf döndürür dize.",
  "ExpressionEditorStringId.Function_UtcNow": "UtcNow()\nGeçerli sistem tarihi ve saati, Eşgüdümlü Evrensel Saat (UTC) olarak ifade edilen verir.",
  "ExpressionEditorStringId.Operator_And": "İki ifade üzerinde mantıksal birleşim yapar.",
  "ExpressionEditorStringId.Operator_Between": "Arasinda(,)\nTest edilmek üzere bir aralık belirtir. Eğer bir değer ilk parametreden büyükse veya ona eşitse ve ikinci parametreden küçükse veya ona eşitse true döner.",
  "ExpressionEditorStringId.Operator_BitwiseAnd": "İki integer değer arasında bitsel mantıksal VE işlemi yapar.",
  "ExpressionEditorStringId.Operator_BitwiseOr": "İlk parametresinin her bir bitini ikinci parametrede karşılık gelen bitle karşılaştırır. Eğer ikisi de 1 ise, ilgili sonuç biti 1 olur. Değilse 0 olur.",
  "ExpressionEditorStringId.Operator_BitwiseXor": "İki Boolean ifade arasında mantıksal çıkarma veya iki numerik ifade arasında bitsel çıkarma işlemi yapar.",
  "ExpressionEditorStringId.Operator_Divide": "İlk parametreyi ikinciye böler.",
  "ExpressionEditorStringId.Operator_Equal": "İki parametre aynı değere sahipse True döner, yoksa False döner.",
  "ExpressionEditorStringId.Operator_Greater": "Büyüktür operatörü. İfadeleri karşılaştırmakta kullanılır.",
  "ExpressionEditorStringId.Operator_GreaterOrEqual": "Büyük eşittir operatörü. İfadeleri karşılaştırmakta kullanılır.",
  "ExpressionEditorStringId.Operator_In": "In (,,,)\nBir nesnede bir özelliğin varlığını test eder.",
  "ExpressionEditorStringId.Operator_Less": "Küçüktür operatörü. İfadeleri karşılaştırmakta kullanılır.",
  "ExpressionEditorStringId.Operator_LessOrEqual": "Küçük eşittir operatörü. İfadeleri karşılaştırmakta kullanılır.",
  "ExpressionEditorStringId.Operator_Like": "Bir stringi bir desen ile karşılaştırır. Eğer string ile desen uyuşursa sonuç true olur. Eğer string ile desen uyuşmazsa sonuç false olur. Eğer string ve desen boş string'ler ise sonuç true olur.",
  "ExpressionEditorStringId.Operator_Minus": "İki sayının farkını bulur.",
  "ExpressionEditorStringId.Operator_Modulo": "Bir sayısal ifadenin diğerine bölümünden kalanı(mod) döner.",
  "ExpressionEditorStringId.Operator_Multiply": "İki ifadenin değerini çarpar.",
  "ExpressionEditorStringId.Operator_Not": "Bir ifadede mantıksal çıkarma yapar.",
  "ExpressionEditorStringId.Operator_NotEqual": "İşlenen iki değer farklıysa true döner, aynıysa false döner.",
  "ExpressionEditorStringId.Operator_Or": "İki Boolean değer üzerinde mantıksal ayrım gerçekleştirir.",
  "ExpressionEditorStringId.Operator_Plus": "Sayısal bir ifadeyi diğeriyle toplar veya iki string'i birbirine ekler.",
  "FilterUIElementLocalizerStringId.CustomUIFilterAboveAverageDescription": "Değerleri ortalamanın üzerinde",
  "FilterUIElementLocalizerStringId.CustomUIFilterAboveAverageName": "Ortalamanın üstünde",
  "FilterUIElementLocalizerStringId.CustomUIFilterAfterDescription": "Bir tarihten sonra",
  "FilterUIElementLocalizerStringId.CustomUIFilterAfterName": "Sonra",
  "FilterUIElementLocalizerStringId.CustomUIFilterAllDatesInThePeriodDescription": "Bir aralık içindeki tarihler",
  "FilterUIElementLocalizerStringId.CustomUIFilterAllDatesInThePeriodName": "Dönem içindeki tüm tarihler",
  "FilterUIElementLocalizerStringId.CustomUIFilterAprilDescription": "Nisan",
  "FilterUIElementLocalizerStringId.CustomUIFilterAprilName": "Nisan",
  "FilterUIElementLocalizerStringId.CustomUIFilterAugustDescription": "Ağustos",
  "FilterUIElementLocalizerStringId.CustomUIFilterAugustName": "Ağustos",
  "FilterUIElementLocalizerStringId.CustomUIFilterBeforeDescription": "Bir tarihten önce",
  "FilterUIElementLocalizerStringId.CustomUIFilterBeforeName": "Daha önce",
  "FilterUIElementLocalizerStringId.CustomUIFilterBeginsWithDescription": "Açıklama ile başlar",
  "FilterUIElementLocalizerStringId.CustomUIFilterBeginsWithName": "İle başlar",
  "FilterUIElementLocalizerStringId.CustomUIFilterBelowAverageDescription": "Ortalamanın altında değerler",
  "FilterUIElementLocalizerStringId.CustomUIFilterBelowAverageName": "Ortalamanın altında",
  "FilterUIElementLocalizerStringId.CustomUIFilterBetweenDescription": "Bir aralık içindeki değerleri",
  "FilterUIElementLocalizerStringId.CustomUIFilterBetweenName": "Arasında",
  "FilterUIElementLocalizerStringId.CustomUIFilterBottomNDescription": "En düşük değerler",
  "FilterUIElementLocalizerStringId.CustomUIFilterBottomNName": "Alt N",
  "FilterUIElementLocalizerStringId.CustomUIFilterContainsDescription": "Açıklama içeren",
  "FilterUIElementLocalizerStringId.CustomUIFilterContainsName": "İçerir",
  "FilterUIElementLocalizerStringId.CustomUIFilterCustomDescription": "Özel açıklama",
  "FilterUIElementLocalizerStringId.CustomUIFilterCustomName": "Özel filtre",
  "FilterUIElementLocalizerStringId.CustomUIFilterDatePeriodsName": "Belirli tarih dönemleri",
  "FilterUIElementLocalizerStringId.CustomUIFilterDecemberDescription": "Aralık tanımı",
  "FilterUIElementLocalizerStringId.CustomUIFilterDecemberName": "Aralık",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotBeginWithDescription": "Belirli bir metni ile başlamıyor",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotBeginWithName": "Değil ile başlar",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotBeginsWithDescription": "Belirli bir metni ile başlamıyor",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotBeginsWithName": "Değil ile başlar",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotContainDescription": "Açıklama içermiyor",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotContainName": "İçermez",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotEndWithDescription": "Belirli bir metni ile bitmiyor",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotEndWithName": "Değil ile biter",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotEndsWithDescription": "Belirli bir metni ile bitmiyor",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotEndsWithName": "Değil ile biter",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotEqualDescription": "Açıklama eşit değil",
  "FilterUIElementLocalizerStringId.CustomUIFilterDoesNotEqualName": "eşit değildir",
  "FilterUIElementLocalizerStringId.CustomUIFilterEndsWithDescription": "Açıklama ile biter",
  "FilterUIElementLocalizerStringId.CustomUIFilterEndsWithName": "İle biter",
  "FilterUIElementLocalizerStringId.CustomUIFilterEqualsDescription": "Açıklama eşittir",
  "FilterUIElementLocalizerStringId.CustomUIFilterEqualsName": "Eşittir",
  "FilterUIElementLocalizerStringId.CustomUIFilterFebruaryDescription": "Şubat açıklama",
  "FilterUIElementLocalizerStringId.CustomUIFilterFebruaryName": "Şubat",
  "FilterUIElementLocalizerStringId.CustomUIFilterGreaterThanDescription": "Bir değerden daha büyük",
  "FilterUIElementLocalizerStringId.CustomUIFilterGreaterThanName": "Daha büyük",
  "FilterUIElementLocalizerStringId.CustomUIFilterGreaterThanOrEqualToDescription": "Sıfırdan büyük veya eşit bir değer",
  "FilterUIElementLocalizerStringId.CustomUIFilterGreaterThanOrEqualToName": "Değerinden büyük veya eşit",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsBlankDescription": "Boş açıklamasıdır",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsBlankName": "Boştur",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsNotBlankDescription": "Boş olmayan açıklama",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsNotBlankName": "Boş değil",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsNotNullDescription": "Boş değil",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsNotNullName": "Null değil mi",
  "FilterUIElementLocalizerStringId.CustomUIFilterIsNullDescription": "Boş mu",
  "FilterUIElementLocalizerStringId.CustomUIFilterJanuaryDescription": "Ocak",
  "FilterUIElementLocalizerStringId.CustomUIFilterJanuaryName": "Ocak",
  "FilterUIElementLocalizerStringId.CustomUIFilterJulyDescription": "Temmuz",
  "FilterUIElementLocalizerStringId.CustomUIFilterJulyName": "Temmuz",
  "FilterUIElementLocalizerStringId.CustomUIFilterJuneDescription": "Haziran",
  "FilterUIElementLocalizerStringId.CustomUIFilterJuneName": "Haziran",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastMonthDescription": "Geçen ay",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastMonthName": "Geçen ay",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastQuarterDescription": "Son çeyrek",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastQuarterName": "Son dönem",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastWeekDescription": "Geçen hafta",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastWeekName": "Geçen hafta",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastYearDescription": "Geçen yıl",
  "FilterUIElementLocalizerStringId.CustomUIFilterLastYearName": "Geçen yıl",
  "FilterUIElementLocalizerStringId.CustomUIFilterLessThanDescription": "Bir değer daha az",
  "FilterUIElementLocalizerStringId.CustomUIFilterLessThanName": "Daha az",
  "FilterUIElementLocalizerStringId.CustomUIFilterLessThanOrEqualToName": "Küçük veya eşit",
  "FilterUIElementLocalizerStringId.CustomUIFilterLikeDescription": "Belirli bir deseni eşleştir",
  "FilterUIElementLocalizerStringId.CustomUIFilterMarchDescription": "Mart",
  "FilterUIElementLocalizerStringId.CustomUIFilterMarchName": "Mart",
  "FilterUIElementLocalizerStringId.CustomUIFilterMayDescription": "Mayıs",
  "FilterUIElementLocalizerStringId.CustomUIFilterMayName": "Mayıs",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextMonthDescription": "Gelecek ay",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextMonthName": "Gelecek ay",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextQuarterDescription": "Sonraki çeyrek",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextQuarterName": "Sonraki çeyrek",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextWeekDescription": "Gelecek hafta",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextWeekName": "Gelecek hafta",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextYearDescription": "Gelecek yıl",
  "FilterUIElementLocalizerStringId.CustomUIFilterNextYearName": "Gelecek yıl",
  "FilterUIElementLocalizerStringId.CustomUIFilterNoneDescription": "Bir açıklama seçin",
  "FilterUIElementLocalizerStringId.CustomUIFilterNoneName": "Birini seçin",
  "FilterUIElementLocalizerStringId.CustomUIFilterNovemberDescription": "Kasım",
  "FilterUIElementLocalizerStringId.CustomUIFilterNovemberName": "Kasım",
  "FilterUIElementLocalizerStringId.CustomUIFilterOctoberDescription": "Ekim",
  "FilterUIElementLocalizerStringId.CustomUIFilterOctoberName": "Ekim",
  "FilterUIElementLocalizerStringId.CustomUIFilterQuarter1Name": "Üç aylık dönem 1",
  "FilterUIElementLocalizerStringId.CustomUIFilterQuarter2Description": "İkinci üç aylık dönem",
  "FilterUIElementLocalizerStringId.CustomUIFilterQuarter2Name": "Üç aylık dönem 2",
  "FilterUIElementLocalizerStringId.CustomUIFilterQuarter3Name": "Çeyrek 3",
  "FilterUIElementLocalizerStringId.CustomUIFilterQuarter4Description": "Dördüncü üç aylık dönem",
  "FilterUIElementLocalizerStringId.CustomUIFilterQuarter4Name": "Üç ay 4",
  "FilterUIElementLocalizerStringId.CustomUIFilterSeptemberDescription": "Eylül",
  "FilterUIElementLocalizerStringId.CustomUIFilterSeptemberName": "Eylül",
  "FilterUIElementLocalizerStringId.CustomUIFilterSequenceQualifierItemsDescription": "Öğe Açıklaması",
  "FilterUIElementLocalizerStringId.CustomUIFilterSequenceQualifierItemsName": "Öğeler",
  "FilterUIElementLocalizerStringId.CustomUIFilterSequenceQualifierPercentsDescription": "Yüzdeler açıklama",
  "FilterUIElementLocalizerStringId.CustomUIFilterSequenceQualifierPercentsName": "Yüzdeler",
  "FilterUIElementLocalizerStringId.CustomUIFilterThisMonthDescription": "Bu ay",
  "FilterUIElementLocalizerStringId.CustomUIFilterThisMonthName": "Bu ay",
  "FilterUIElementLocalizerStringId.CustomUIFilterThisQuarterName": "Bu çeyrek",
  "FilterUIElementLocalizerStringId.CustomUIFilterThisWeekDescription": "Bu hafta",
  "FilterUIElementLocalizerStringId.CustomUIFilterThisWeekName": "Bu hafta",
  "FilterUIElementLocalizerStringId.CustomUIFilterThisYearName": "Bu yıl",
  "FilterUIElementLocalizerStringId.CustomUIFilterTodayDescription": "Bugün",
  "FilterUIElementLocalizerStringId.CustomUIFilterTodayName": "Bugün",
  "FilterUIElementLocalizerStringId.CustomUIFilterTomorrowDescription": "Yarın",
  "FilterUIElementLocalizerStringId.CustomUIFilterTomorrowName": "Yarın",
  "FilterUIElementLocalizerStringId.CustomUIFilterTopNDescription": "En yüksek değerler",
  "FilterUIElementLocalizerStringId.CustomUIFilterTopNName": "Üst N",
  "FilterUIElementLocalizerStringId.CustomUIFilterUserDescription": "Önceden tanımlanmış filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFilterUserName": "Önceden tanımlanmış filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFilterYearToDateDescription": "Günümüze yılın başından itibaren",
  "FilterUIElementLocalizerStringId.CustomUIFilterYesterdayDescription": "Dün",
  "FilterUIElementLocalizerStringId.CustomUIFilterYesterdayName": "Dün",
  "FilterUIElementLocalizerStringId.CustomUIFiltersBooleanDescription": "Filtre Açıklaması",
  "FilterUIElementLocalizerStringId.CustomUIFiltersBooleanName": "Filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFiltersDateTimeDescription": "Açıklama tarihe filtre",
  "FilterUIElementLocalizerStringId.CustomUIFiltersDateTimeName": "Tarih filtreleri",
  "FilterUIElementLocalizerStringId.CustomUIFiltersDurationName": "Filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFiltersEnumDescription": "Açıklama filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFiltersEnumName": "Filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFiltersNumericDescription": "Sayısal filtre açıklaması",
  "FilterUIElementLocalizerStringId.CustomUIFiltersNumericName": "Sayısal filtreler",
  "FilterUIElementLocalizerStringId.CustomUIFiltersTextDescription": "Metin filtreleri açıklaması",
  "FilterUIElementLocalizerStringId.CustomUIFiltersTextName": "Metin filtreleri",
  "FilterUIElementLocalizerStringId.CustomUIFirstLabel": "İlk",
  "FilterUIElementLocalizerStringId.CustomUINullValuePromptChooseOne": "Birini seçin...",
  "FilterUIElementLocalizerStringId.CustomUINullValuePromptEnterADate": "Bir tarih girin...",
  "FilterUIElementLocalizerStringId.CustomUINullValuePromptEnterAValue": "Bir değeri girme",
  "FilterUIElementLocalizerStringId.CustomUINullValuePromptSearchControl": "aramak için metni girin",
  "FilterUIElementLocalizerStringId.CustomUINullValuePromptSelectADate": "Bir tarih seçin",
  "FilterUIElementLocalizerStringId.CustomUINullValuePromptSelectAValue": "Bir değer seçin",
  "FilterUIElementLocalizerStringId.CustomUISecondLabel": "İkinci",
  "FilterUIElementLocalizerStringId.CustomUITypeLabel": "Türü",
  "FilterUIElementLocalizerStringId.CustomUIValueLabel": "Değer",
  "FilterUIElementLocalizerStringId.FilteringUIClearFilter": "Filtreyi temizle",
  "FilterUIElementLocalizerStringId.FilteringUIClose": "Kapat",
  "FilterUIElementLocalizerStringId.FilteringUISearchByDayCaption": "Gün",
  "FilterUIElementLocalizerStringId.FilteringUISearchByMonthCaption": "Ay",
  "FilterUIElementLocalizerStringId.FilteringUISearchByYearCaption": "Yıl",
  "FilterUIElementLocalizerStringId.FilteringUITabGroups": "Gruplar",
  "FilterUIElementLocalizerStringId.FilteringUITabValues": "Değerler",
  "FilteringLocalizerStringId.BlanksName": "(Boş olanlar)",
  "FilteringLocalizerStringId.DefaultName": "Varsayılan",
  "FilteringLocalizerStringId.EmptyName": "(Boş)",
  "FilteringLocalizerStringId.FalseName": "Yanlış",
  "FilteringLocalizerStringId.MenuClearSelectionName": "Seçimi Temizle",
  "FilteringLocalizerStringId.MenuInvertSelectionName": "Seçimi tersine çevir",
  "FilteringLocalizerStringId.MenuResetAllFilters": "Tüm Filtreleri Sıfırla",
  "FilteringLocalizerStringId.MenuResetFilter": "Filtreyi Sıfırla",
  "FilteringLocalizerStringId.MenuSelectAllName": "Tümünü Seç",
  "FilteringLocalizerStringId.NonBlanksName": "(Boş Olmayanlar)",
  "FilteringLocalizerStringId.SelectAllName": "Tüm",
  "FilteringLocalizerStringId.TrueName": "Doğru",
  "PreviewStringId.Accessibility_Chart_Name": "Grafik",
  "PreviewStringId.Accessibility_Gauge_Name": "ölçer",
  "PreviewStringId.Accessibility_Image_Name": "Resim",
  "PreviewStringId.Accessibility_Line_Name": "Çizgi",
  "PreviewStringId.Accessibility_Shape_Name": "Şekil",
  "PreviewStringId.Accessibility_Sparkline_Name": "Mini grafik",
  "PreviewStringId.BarText_MainMenu": "Ana Menü",
  "PreviewStringId.BarText_StatusBar": "Durum Çubuğu",
  "PreviewStringId.BarText_Toolbar": "Araç Çubuğu",
  "PreviewStringId.Button_Apply": "Uygula",
  "PreviewStringId.Button_Cancel": "İptal",
  "PreviewStringId.Button_Help": "Yardım",
  "PreviewStringId.Button_Ok": "Tamam",
  "PreviewStringId.DateRangeParameterEditor_LastMonth": "Geçen ay",
  "PreviewStringId.DateRangeParameterEditor_LastWeek": "Geçen hafta",
  "PreviewStringId.DateRangeParameterEditor_Today": "Bugün",
  "PreviewStringId.DateRangeParameterEditor_Yesterday": "Dün",
  "PreviewStringId.EMail_From": "Kimden",
  "PreviewStringId.EditingFieldEditorCategories_DateTime": "Tarih-Saat",
  "PreviewStringId.EditingFieldEditorCategories_Letters": "Mektuplar",
  "PreviewStringId.EditingFieldEditorCategories_Numeric": "Sayısal",
  "PreviewStringId.EditingFieldEditors_Date": "Tarih",
  "PreviewStringId.EditingFieldEditors_FixedPoint": "Sabit noktalı",
  "PreviewStringId.EditingFieldEditors_FixedPointPositive": "Sabit noktalı pozitif",
  "PreviewStringId.EditingFieldEditors_Image": "Resim",
  "PreviewStringId.EditingFieldEditors_Integer": "Tamsayı",
  "PreviewStringId.EditingFieldEditors_IntegerPositive": "Tamsayı pozitif",
  "PreviewStringId.EditingFieldEditors_OnlyUppercaseLetters": "Sadece büyük harfler",
  "PreviewStringId.ExportOption_ConfirmOpenPasswordForm_Caption": "Doküman Açma Şifresini Onaylayın",
  "PreviewStringId.ExportOption_ConfirmOpenPasswordForm_Name": "Doküman Açma Şifresi:",
  "PreviewStringId.ExportOption_ConfirmOpenPasswordForm_Note": "Lütfen doküman açma şifresini onaylayın. Şifreyi not almayı unutmayın. Dokümanı açmak için bu şifre sorulacaktır.",
  "PreviewStringId.ExportOption_ConfirmPermissionsPasswordForm_Caption": "İzin Şifresini Onaylayın",
  "PreviewStringId.ExportOption_ConfirmPermissionsPasswordForm_Name": "İzin Şifresi:",
  "PreviewStringId.ExportOption_ConfirmPermissionsPasswordForm_Note": "Lütfen izin şifresini onaylayın. Şifreyi not almayı unutmayın. Ayarları değiştirmek için bu şifre sorulacaktır.",
  "PreviewStringId.ExportOption_ConfirmationDoesNotMatchForm_Msg": "Girilen şifreler uyumsuz. Lütfen tekrar giriş yapınız.",
  "PreviewStringId.ExportOption_CsvSeparator_UsingSystem": "(Sistem ayırıcı kullanarak)",
  "PreviewStringId.ExportOption_DocxExportMode": "Dışarı aktarma modu:",
  "PreviewStringId.ExportOption_DocxExportMode_SingleFile": "Tek dosya",
  "PreviewStringId.ExportOption_DocxExportMode_SingleFilePageByPage": "Sayfa sayfa tek dosya",
  "PreviewStringId.ExportOption_DocxKeepRowHeight": "Satır yüksekliğini koru",
  "PreviewStringId.ExportOption_DocxPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_DocxTableLayout": "Tablo düzeni",
  "PreviewStringId.ExportOption_HtmlCharacterSet": "Karakter Seti:",
  "PreviewStringId.ExportOption_HtmlEmbedImagesInHTML": "Resimleri HTML'e göm",
  "PreviewStringId.ExportOption_HtmlExportMode": "Dışarı aktarma modu:",
  "PreviewStringId.ExportOption_HtmlExportMode_DifferentFiles": "Farklı dosyalar",
  "PreviewStringId.ExportOption_HtmlExportMode_SingleFile": "Tek dosya",
  "PreviewStringId.ExportOption_HtmlExportMode_SingleFilePageByPage": "Sayfa sayfa tek dosya",
  "PreviewStringId.ExportOption_HtmlPageBorderColor": "Sayfa çerçeve rengi:",
  "PreviewStringId.ExportOption_HtmlPageBorderWidth": "Sayfa çerçeve kalınlığı:",
  "PreviewStringId.ExportOption_HtmlPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_HtmlRemoveSecondarySymbols": "Satırbaşlarını kaldır",
  "PreviewStringId.ExportOption_HtmlTableLayout": "Tablo Düzeni",
  "PreviewStringId.ExportOption_HtmlTitle": "Başlık:",
  "PreviewStringId.ExportOption_ImageExportMode": "Dışarı aktarma modu:",
  "PreviewStringId.ExportOption_ImageExportMode_DifferentFiles": "Farklı dosyalar",
  "PreviewStringId.ExportOption_ImageExportMode_SingleFile": "Tek dosya",
  "PreviewStringId.ExportOption_ImageExportMode_SingleFilePageByPage": "Sayfa sayfa tek dosya",
  "PreviewStringId.ExportOption_ImageFormat": "Resim formatı:",
  "PreviewStringId.ExportOption_ImagePageBorderColor": "Sayfa çerçeve rengi:",
  "PreviewStringId.ExportOption_ImagePageBorderWidth": "Sayfa çerçeve kalınlığı:",
  "PreviewStringId.ExportOption_ImagePageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_ImageResolution": "Çözünürlük (dpi):",
  "PreviewStringId.ExportOption_NativeFormatCompressed": "Sıkıştırılmış",
  "PreviewStringId.ExportOption_PdfACompatibility": "PDF/A-2b",
  "PreviewStringId.ExportOption_PdfACompatibility_None": "Hiçbiri",
  "PreviewStringId.ExportOption_PdfACompatibility_PdfA1b": "PDF/A-1b",
  "PreviewStringId.ExportOption_PdfACompatibility_PdfA2b": "PDF/A-2b",
  "PreviewStringId.ExportOption_PdfACompatibility_PdfA3b": "PDF/A-3b",
  "PreviewStringId.ExportOption_PdfChangingPermissions_AnyExceptExtractingPages": "Sayfaları çıkarmak dışında herhangi biri",
  "PreviewStringId.ExportOption_PdfChangingPermissions_CommentingFillingSigning": "Yorum eklemek, form alanlarını doldurmak ve var olan imza alanlarını imzalamak",
  "PreviewStringId.ExportOption_PdfChangingPermissions_FillingSigning": "Form alanlarını doldurmak ve varolan imza alanlarını imzalamak",
  "PreviewStringId.ExportOption_PdfChangingPermissions_InsertingDeletingRotating": "Sayfa eklemek, çıkarmak veya döndürmek",
  "PreviewStringId.ExportOption_PdfChangingPermissions_None": "Hiçbiri",
  "PreviewStringId.ExportOption_PdfConvertImagesToJpeg": "Resimleri JPEG'e dönüştür",
  "PreviewStringId.ExportOption_PdfDocumentApplication": "Uygulama:",
  "PreviewStringId.ExportOption_PdfDocumentAuthor": "Yazar:",
  "PreviewStringId.ExportOption_PdfDocumentKeywords": "Anahtar Kelimeler:",
  "PreviewStringId.ExportOption_PdfDocumentSubject": "Konu:",
  "PreviewStringId.ExportOption_PdfDocumentTitle": "Başlık:",
  "PreviewStringId.ExportOption_PdfImageQuality": "Resim kalitesi:",
  "PreviewStringId.ExportOption_PdfImageQuality_High": "Yüksek",
  "PreviewStringId.ExportOption_PdfImageQuality_Highest": "En Yüksek",
  "PreviewStringId.ExportOption_PdfImageQuality_Low": "Düşük",
  "PreviewStringId.ExportOption_PdfImageQuality_Lowest": "En Düşük",
  "PreviewStringId.ExportOption_PdfImageQuality_Medium": "Orta",
  "PreviewStringId.ExportOption_PdfNeverEmbeddedFonts": "Bu fontları gömme:",
  "PreviewStringId.ExportOption_PdfPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_PdfPasswordSecurityOptions": "Şifre Güvenliği:",
  "PreviewStringId.ExportOption_PdfPasswordSecurityOptions_DocumentOpenPassword": "Doküman Açma Şifresi:",
  "PreviewStringId.ExportOption_PdfPasswordSecurityOptions_None": "(hiçbiri)",
  "PreviewStringId.ExportOption_PdfPasswordSecurityOptions_Permissions": "İzinler",
  "PreviewStringId.ExportOption_PdfPrintingPermissions_HighResolution": "Yüksek Çözünürlük",
  "PreviewStringId.ExportOption_PdfPrintingPermissions_LowResolution": "Düşük Çözünürlük (150 dpi)",
  "PreviewStringId.ExportOption_PdfPrintingPermissions_None": "Hiçbiri",
  "PreviewStringId.ExportOption_PdfShowPrintDialogOnOpen": "Açılışta yazdırma dialogunu göster",
  "PreviewStringId.ExportOption_PdfSignatureOptions": "Dijital imza:",
  "PreviewStringId.ExportOption_PdfSignatureOptions_Certificate": "Sertifika",
  "PreviewStringId.ExportOption_PdfSignatureOptions_ContactInfo": "İletişim bilgileri",
  "PreviewStringId.ExportOption_PdfSignatureOptions_Image": "Resim",
  "PreviewStringId.ExportOption_PdfSignatureOptions_Location": "Konumu",
  "PreviewStringId.ExportOption_PdfSignatureOptions_None": "(yok)",
  "PreviewStringId.ExportOption_PdfSignatureOptions_Reason": "Nedeni",
  "PreviewStringId.ExportOption_PdfSignature_EmptyCertificate": "Hiçbiri",
  "PreviewStringId.ExportOption_PdfSignature_Issuer": "Veren kuruluş:",
  "PreviewStringId.ExportOption_PdfSignature_ValidRange": "İtibaren geçerli: {0:d} {1:d} için",
  "PreviewStringId.ExportOption_PdfUACompatibility_None": "Hiçbiri",
  "PreviewStringId.ExportOption_RtfExportMode": "Dışarı aktarma modu:",
  "PreviewStringId.ExportOption_RtfExportMode_SingleFile": "Tek dosya",
  "PreviewStringId.ExportOption_RtfExportMode_SingleFilePageByPage": "Sayfa sayfa tek dosya",
  "PreviewStringId.ExportOption_RtfExportWatermarks": "Filigranları dışarı aktar",
  "PreviewStringId.ExportOption_RtfPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_TextEncoding": "Dil Kodlaması:",
  "PreviewStringId.ExportOption_TextExportMode": "Metin dışarı aktarma modu:",
  "PreviewStringId.ExportOption_TextExportMode_Text": "Metin",
  "PreviewStringId.ExportOption_TextExportMode_Value": "Değer",
  "PreviewStringId.ExportOption_TextQuoteStringsWithSeparators": "String'leri ayraçlarla alıntıla",
  "PreviewStringId.ExportOption_TextSeparator": "Metin Ayracı:",
  "PreviewStringId.ExportOption_TextSeparator_TabAlias": "SEKME",
  "PreviewStringId.ExportOption_XlsExportHyperlinks": "Hyperlink'leri dışarı aktar",
  "PreviewStringId.ExportOption_XlsExportMode": "Dışarı aktarma modu:",
  "PreviewStringId.ExportOption_XlsExportMode_DifferentFiles": "Farklı dosyalar",
  "PreviewStringId.ExportOption_XlsExportMode_SingleFile": "Tek dosya",
  "PreviewStringId.ExportOption_XlsExportMode_SingleFilePageByPage": "Sayfa sayfa tek dosya",
  "PreviewStringId.ExportOption_XlsPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_XlsRawDataMode": "Ham veri modu",
  "PreviewStringId.ExportOption_XlsSheetName": "Sayfa Adı:",
  "PreviewStringId.ExportOption_XlsShowGridLines": "Grid çizgilerini göster",
  "PreviewStringId.ExportOption_XlsxExportMode": "Dışarı aktarma modu:",
  "PreviewStringId.ExportOption_XlsxExportMode_DifferentFiles": "Farklı dosyalar",
  "PreviewStringId.ExportOption_XlsxExportMode_SingleFile": "Tek dosya",
  "PreviewStringId.ExportOption_XlsxExportMode_SingleFilePageByPage": "Sayfa sayfa tek dosya",
  "PreviewStringId.ExportOption_XlsxPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOption_XpsCompression": "Sıkıştırma:",
  "PreviewStringId.ExportOption_XpsCompression_Fast": "Hızlı",
  "PreviewStringId.ExportOption_XpsCompression_Maximum": "En Yüksek",
  "PreviewStringId.ExportOption_XpsCompression_Normal": "Normal",
  "PreviewStringId.ExportOption_XpsCompression_NotCompressed": "Sıkıştırma Yok",
  "PreviewStringId.ExportOption_XpsCompression_SuperFast": "En Hızlı",
  "PreviewStringId.ExportOption_XpsDocumentCategory": "Kategori:",
  "PreviewStringId.ExportOption_XpsDocumentCreator": "Yaratıcı:",
  "PreviewStringId.ExportOption_XpsDocumentDescription": "Açıklama:",
  "PreviewStringId.ExportOption_XpsDocumentKeywords": "Anahtar Kelimeler:",
  "PreviewStringId.ExportOption_XpsDocumentSubject": "Konu:",
  "PreviewStringId.ExportOption_XpsDocumentTitle": "Başlık:",
  "PreviewStringId.ExportOption_XpsDocumentVersion": "Versiyon:",
  "PreviewStringId.ExportOption_XpsPageRange": "Sayfa aralığı:",
  "PreviewStringId.ExportOptionsForm_CaptionCsv": "CSV Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionHtml": "HTML Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionImage": "Resim Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionMht": "MHT Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionNativeOptions": "Doğal Format Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionPdf": "PDF Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionRtf": "RTF Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionTxt": "Metin Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionXls": "XLS Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionXlsx": "XLSX Dışarı Aktarma Seçenekleri",
  "PreviewStringId.ExportOptionsForm_CaptionXps": "XPS Dışarı Aktarma Seçenekleri",
  "PreviewStringId.FolderBrowseDlg_ExportDirectory": "Aktarılan dosyanın kaydedileceği dizini seçiniz:",
  "PreviewStringId.ImageEditingFieldEditor_Alignment": "Hizalama",
  "PreviewStringId.ImageEditingFieldEditor_Clear": "Temizle",
  "PreviewStringId.ImageEditingFieldEditor_Reset": "Sıfırla",
  "PreviewStringId.ImageEditingFieldEditor_SizeMode": "Boyutu modu",
  "PreviewStringId.MPForm_Lbl_Pages": "Sayfalar",
  "PreviewStringId.Margin_BottomMargin": "Alt Kenar Boşluğu",
  "PreviewStringId.Margin_Inch": "İnç",
  "PreviewStringId.Margin_LeftMargin": "Sol Kenar Boşluğu",
  "PreviewStringId.Margin_Millimeter": "mm",
  "PreviewStringId.Margin_RightMargin": "Sağ Kenar Boşluğu",
  "PreviewStringId.Margin_TopMargin": "Üst Kenar Boşluğu",
  "PreviewStringId.MenuItem_BackgrColor": "Renk...",
  "PreviewStringId.MenuItem_Background": "Arkaplan",
  "PreviewStringId.MenuItem_Copy": "Kopyala",
  "PreviewStringId.MenuItem_CsvDocument": "CSV Dosyası",
  "PreviewStringId.MenuItem_DocxDocument": "DOCX dosya",
  "PreviewStringId.MenuItem_Exit": "Çıkış",
  "PreviewStringId.MenuItem_Export": "Dışarı Aktar",
  "PreviewStringId.MenuItem_File": "Dosya",
  "PreviewStringId.MenuItem_GraphicDocument": "Resim Dosyası",
  "PreviewStringId.MenuItem_HtmDocument": "HTML Dosyası",
  "PreviewStringId.MenuItem_MhtDocument": "MHT Dosyası",
  "PreviewStringId.MenuItem_PageLayout": "Sayfa Yerleşimi",
  "PreviewStringId.MenuItem_PageSetup": "Sayfa Düzeni",
  "PreviewStringId.MenuItem_PdfDocument": "PDF Dosyası",
  "PreviewStringId.MenuItem_Print": "Yazdır...",
  "PreviewStringId.MenuItem_PrintDirect": "Doğrudan Yazdır",
  "PreviewStringId.MenuItem_PrintSelection": "Yazdır...",
  "PreviewStringId.MenuItem_RtfDocument": "RTF Dosyası",
  "PreviewStringId.MenuItem_Send": "Farklı Gönder",
  "PreviewStringId.MenuItem_TxtDocument": "Metin Dosyası",
  "PreviewStringId.MenuItem_View": "Göster",
  "PreviewStringId.MenuItem_ViewContinuous": "Sürekli",
  "PreviewStringId.MenuItem_ViewFacing": "Karşı",
  "PreviewStringId.MenuItem_ViewStatusbar": "Durum Çubuğu",
  "PreviewStringId.MenuItem_ViewToolbar": "Araç Çubuğu",
  "PreviewStringId.MenuItem_Watermark": "Filigran...",
  "PreviewStringId.MenuItem_XlsDocument": "XLS Dosyası",
  "PreviewStringId.MenuItem_XlsxDocument": "XLSX Dosyası",
  "PreviewStringId.MenuItem_ZoomPageWidth": "Sayfa Genişliği",
  "PreviewStringId.MenuItem_ZoomTextWidth": "Metin Genişliği",
  "PreviewStringId.MenuItem_ZoomTwoPages": "İki Sayfa",
  "PreviewStringId.MenuItem_ZoomWholePage": "Tüm Sayfa",
  "PreviewStringId.Msg_BigBitmapToCreate": "Çıktı dosyası çok büyük. Resim çözünürlüğünü azaltın veya başka bir aktarım modu seçin.",
  "PreviewStringId.Msg_BigFileToCreate": "Çıktı dosyası çok büyük. Sayfa sayısını azaltın veya dokümanı bölmeyi deneyin.",
  "PreviewStringId.Msg_BigFileToCreateJPEG": "Çıktı dosyası JPEG oluşturmak için çok büyük. Başka bir resim formatı veya aktarım modu seçin.",
  "PreviewStringId.Msg_CannotAccessFile": "Başka bir işlem tarafından kullanıldığı için \"{0}\" dosyasına erişilemiyor.",
  "PreviewStringId.Msg_CannotLoadDocument": "Belirtilen dosya geçerli XML formatında olmadığı için veya izin verilen boyuttan büyük olduğu için yüklenemiyor. ",
  "PreviewStringId.Msg_CantFitBarcodeToControlBounds": "Kontrol sınırları barkod için çok küçük",
  "PreviewStringId.Msg_Caption": "Yazdırılıyor",
  "PreviewStringId.Msg_CreatingDocument": "Doküman oluşturuluyor...",
  "PreviewStringId.Msg_CustomDrawWarning": "Uyarı!",
  "PreviewStringId.Msg_EmptyDocument": "Bu dokümanda sayfa bulunmuyor.",
  "PreviewStringId.Msg_EmptyUsefulPageSizeError": "Sayfa kenar boşluklarını sayfa boyutundan daha büyük.",
  "PreviewStringId.Msg_ErrorTitle": "Hata",
  "PreviewStringId.Msg_FileAlreadyExists": "Çıkış dosyası zaten var. Üzerine yazmak için Tamam'ı tıklatın.",
  "PreviewStringId.Msg_FileDoesNotContainValidXml": "Belirtilen dosya PRNX formatında geçerli XML verisi içermiyor. Yükleme durduruldu.",
  "PreviewStringId.Msg_FileDoesNotHavePrnxExtension": "Belirtilen dosya PRNX uzantısına sahip değil. Devam edilsin mi?",
  "PreviewStringId.Msg_FileReadOnly": "\"{0}\" dosyası sadece okunabilir, farklı bir dosya ismi girmeyi deneyin.",
  "PreviewStringId.Msg_FontInvalidNumber": "Font boyutu 0'dan büyük olmalı",
  "PreviewStringId.Msg_GoToNonExistentPage": "Bu dokümanda {0} numaralı sayfa yok",
  "PreviewStringId.Msg_IncorrectPageRange": "Geçerli bir sayfa aralığı değil",
  "PreviewStringId.Msg_IncorrectZoomFactor": "Numara {0}-{1} aralığında olmalı",
  "PreviewStringId.Msg_InvPropName": "Geçersiz özellik adı",
  "PreviewStringId.Msg_InvalidBarcodeData": "Binary veri {0} byte'dan fazla olamaz",
  "PreviewStringId.Msg_InvalidBarcodeText": "Metin içerisinde geçersiz karakterler var",
  "PreviewStringId.Msg_InvalidBarcodeTextFormat": "Geçersiz metin formatı",
  "PreviewStringId.Msg_InvalidMeasurement": "Geçerli bir ölçüm değil",
  "PreviewStringId.Msg_InvalidatePath": "Belirtilen yolu bulamıyor",
  "PreviewStringId.Msg_NeedPrinter": "Yüklü yazıcı yok",
  "PreviewStringId.Msg_NoDifferentFilesInStream": "Bir doküman FarklıSayfalar modunda bir stream'e aktarılamaz. TekDosya veya SayfaSayfaTekDosya modunu deneyin.",
  "PreviewStringId.Msg_NoParameters": "Belirtilen parametreler bulunamadı:{0}",
  "PreviewStringId.Msg_NotSupportedFont": "Bu yazı tipi henüz desteklenmiyor.",
  "PreviewStringId.Msg_OpenFileQuestion": "Bu dosyayı açmak istiyor musunuz?",
  "PreviewStringId.Msg_OpenFileQuestionCaption": "Dışarı Aktar",
  "PreviewStringId.Msg_PageMarginsWarning": "Bir veya daha fazla kenar boşluğu yazdırılabilir alanın dışında. Devam edilsin mi?",
  "PreviewStringId.Msg_PathTooLong": "Adres çok uzun.\nDaha kısa bir isim deneyin.",
  "PreviewStringId.Msg_Search_Caption": "Arama",
  "PreviewStringId.Msg_SeparatorCannotBeEmptyString": "Ayırıcı boş bir dize olamaz.",
  "PreviewStringId.Msg_UnavailableNetPrinter": "Net yazıcı uygun değil.",
  "PreviewStringId.Msg_WrongPageSettings": "Geçerli yazıcı seçilen sayfa boyutunu desteklemiyor.\nYine de devam et?",
  "PreviewStringId.Msg_WrongPrinter": "Yazıcı adı geçersiz. Yazıcı ayarlarını kontrol edin.",
  "PreviewStringId.Msg_WrongPrinting": "Dokümanın yazdırılması sırasında hata oluştu.",
  "PreviewStringId.Msg_XlsMoreThanMaxColumns": "256'dan fazla kolon içerdiği için yaratılan XLS dosyası XLS formatı için fazla büyük.\nLütfen XLSX formatını kullanmayı deneyin.",
  "PreviewStringId.Msg_XlsMoreThanMaxRows": "65536'dan fazla satır içerdiği için yaratılan XLS dosyası XLS formatı için fazla büyük.\nLütfen XLSX formatını kullanmayı deneyin.",
  "PreviewStringId.Msg_XlsxMoreThanMaxColumns": "16,384'den fazla kolon içerdiği için yaratılan XLSX dosyası XLSX formatı için fazla büyük.\nLütfen kolon sayısını azaltın ve tekrar deneyin.",
  "PreviewStringId.Msg_XlsxMoreThanMaxRows": "1,048,576'dan fazla satır içerdiği için yaratılan XLSX dosyası XLSX formatı için fazla büyük.\nLütfen satır sayısını azaltın ve tekrar deneyin.",
  "PreviewStringId.NetworkPrinterFormat": "{1} üzerindeki {0}",
  "PreviewStringId.NoneString": "(hiçbiri)",
  "PreviewStringId.OpenFileDialog_Filter": "Doküman Dosyalarını Önizle (*{0})|*{0}|Tüm Dosyalar (*.*)|*.*",
  "PreviewStringId.OpenFileDialog_Title": "Aç",
  "PreviewStringId.PageInfo_PageDate": "[Yazdırma Tarihi]",
  "PreviewStringId.PageInfo_PageNumber": "[Sayfa #]",
  "PreviewStringId.PageInfo_PageNumberOfTotal": "[#/#]",
  "PreviewStringId.PageInfo_PageTime": "[Yazdırma Saati]",
  "PreviewStringId.PageInfo_PageTotal": "[Sayfalar #]",
  "PreviewStringId.PageInfo_PageUserName": "[Kullanıcı Adı]",
  "PreviewStringId.ParameterLookUpSettingsNoLookUp": "Tarama Yok",
  "PreviewStringId.ParametersRequest_Caption": "Değişkenler",
  "PreviewStringId.ParametersRequest_NullValuePrompt": "(yok)",
  "PreviewStringId.ParametersRequest_Reset": "Sıfırla",
  "PreviewStringId.ParametersRequest_Submit": "Gönder",
  "PreviewStringId.PreviewForm_Caption": "Önizle",
  "PreviewStringId.PrintDialog_Duplex_Simplex": "Hiçbiri",
  "PreviewStringId.PrinterStatus_Busy": "Yazıcı meşgul.",
  "PreviewStringId.PrinterStatus_DriverUpdateNeeded": "Yazıcı sürücüsünü güncelleştirmeniz gerekiyor.",
  "PreviewStringId.PrinterStatus_Error": "Hata",
  "PreviewStringId.PrinterStatus_Initializing": "Önizleme başlatılıyor",
  "PreviewStringId.PrinterStatus_NoToner": "Yazıcıda toner yok.",
  "PreviewStringId.PrinterStatus_NotAvailable": "Yazıcı kullanılamıyor.",
  "PreviewStringId.PrinterStatus_Offline": "Yazıcı çevrimdışı.",
  "PreviewStringId.PrinterStatus_PaperJam": "Kağıt sıkıştı.",
  "PreviewStringId.PrinterStatus_PaperOut": "Yazıcıda kağıt yok.",
  "PreviewStringId.PrinterStatus_Paused": "Yazıcı duraklatıldı.",
  "PreviewStringId.PrinterStatus_Ready": "Yazıcı hazır.",
  "PreviewStringId.PrinterStatus_ServerUnknown": "Sunucu bilinmiyor.",
  "PreviewStringId.PrinterStatus_TonerLow": "Toner az.",
  "PreviewStringId.PrinterStatus_UserIntervention": "Kullanıcı müdahalesi oluştu.",
  "PreviewStringId.PrinterStatus_WarmingUp": "Yazıcı ısınıyor.",
  "PreviewStringId.ReportDesignAnalyzer_GridColumn_Description": "Açıklama",
  "PreviewStringId.RibbonPreview_ClosePreview_Caption": "Yazdırma Önizlemeyi Kapat",
  "PreviewStringId.RibbonPreview_ClosePreview_STipContent": "Doküman'ın Yazdırma Önizlemesini Kapat",
  "PreviewStringId.RibbonPreview_ClosePreview_STipTitle": "Yazdırma Önizlemeyi Kapat",
  "PreviewStringId.RibbonPreview_Customize_Caption": "Seçenekler",
  "PreviewStringId.RibbonPreview_Customize_STipContent": "Yazdırma Seçeneklerini Aç",
  "PreviewStringId.RibbonPreview_Customize_STipTitle": "Seçenekler",
  "PreviewStringId.RibbonPreview_DocumentMap_Caption": "Yer İmleri",
  "PreviewStringId.RibbonPreview_DocumentMap_STipContent": "Doküman Haritasını Aç",
  "PreviewStringId.RibbonPreview_DocumentMap_STipTitle": "Doküman Haritası",
  "PreviewStringId.RibbonPreview_EditPageHF_Caption": "Başlık/Altlık",
  "PreviewStringId.RibbonPreview_EditPageHF_STipContent": "Doküman başlık ve altlığını düzenle",
  "PreviewStringId.RibbonPreview_EditPageHF_STipTitle": "Başlık ve Altlık",
  "PreviewStringId.RibbonPreview_ExportCsv_Caption": "CSV Dosyası",
  "PreviewStringId.RibbonPreview_ExportCsv_Description": "CSV Dosyası",
  "PreviewStringId.RibbonPreview_ExportCsv_STipContent": "Dokümanı CSV dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportCsv_STipTitle": "CSV'ye Aktar",
  "PreviewStringId.RibbonPreview_ExportDocx_STipContent": "DOCX için belgeyi dışa aktarın ve üzerinde bir dosya kaydetmek.",
  "PreviewStringId.RibbonPreview_ExportDocx_STipTitle": "DOCX için dışa aktarma",
  "PreviewStringId.RibbonPreview_ExportFile_Caption": "Dışarı Aktar",
  "PreviewStringId.RibbonPreview_ExportFile_STipContent": "Dokümanı geçerli bir resim dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportFile_STipTitle": "Dışarı Aktar",
  "PreviewStringId.RibbonPreview_ExportGraphic_Caption": "Resim Dosyası",
  "PreviewStringId.RibbonPreview_ExportGraphic_Description": "BMP, GIF, JPEG, PNG, TIFF, EMF, WMF",
  "PreviewStringId.RibbonPreview_ExportGraphic_STipContent": "Dokümanı geçerli bir resim dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportGraphic_STipTitle": "Resim'e Aktar",
  "PreviewStringId.RibbonPreview_ExportHtm_Caption": "HTML Dosyası",
  "PreviewStringId.RibbonPreview_ExportHtm_Description": "Web Sayfası",
  "PreviewStringId.RibbonPreview_ExportHtm_STipContent": "Dokümanı HTML dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportHtm_STipTitle": "HTML'e Aktar",
  "PreviewStringId.RibbonPreview_ExportMht_Caption": "MHT Dosyası",
  "PreviewStringId.RibbonPreview_ExportMht_Description": "Tek Dosya Web Sayfası",
  "PreviewStringId.RibbonPreview_ExportMht_STipContent": "Dokümanı MHT dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportMht_STipTitle": "MHT'ye Aktar",
  "PreviewStringId.RibbonPreview_ExportPdf_Caption": "PDF Dosyası",
  "PreviewStringId.RibbonPreview_ExportPdf_Description": "Adobe Taşınabilir Doküman Formatı",
  "PreviewStringId.RibbonPreview_ExportPdf_STipContent": "Dokümanı PDF dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportPdf_STipTitle": "PDF'ye Aktar",
  "PreviewStringId.RibbonPreview_ExportRtf_Caption": "RTF Dosyası",
  "PreviewStringId.RibbonPreview_ExportRtf_Description": "Zengin Metin Formatı",
  "PreviewStringId.RibbonPreview_ExportRtf_STipContent": "Dokümanı RTF dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportRtf_STipTitle": "RTF'ye Aktar",
  "PreviewStringId.RibbonPreview_ExportTxt_Caption": "Metin Dosyası",
  "PreviewStringId.RibbonPreview_ExportTxt_Description": "Metin Dosyası",
  "PreviewStringId.RibbonPreview_ExportTxt_STipContent": "Dokümanı Metin dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportTxt_STipTitle": "Metin'e Aktar",
  "PreviewStringId.RibbonPreview_ExportXls_Caption": "XLS Dosyası",
  "PreviewStringId.RibbonPreview_ExportXls_Description": "Microsoft Excel Workbook",
  "PreviewStringId.RibbonPreview_ExportXls_STipContent": "Dokümanı XLS dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportXls_STipTitle": "XLS'ye Aktar",
  "PreviewStringId.RibbonPreview_ExportXlsx_Caption": "XLSX Dosyası",
  "PreviewStringId.RibbonPreview_ExportXlsx_Description": "Microsoft Excel çalışma kitabı",
  "PreviewStringId.RibbonPreview_ExportXlsx_STipContent": "Dokümanı XLSX dosyasına aktar ve diske kaydet",
  "PreviewStringId.RibbonPreview_ExportXlsx_STipTitle": "XLSX'e Aktar",
  "PreviewStringId.RibbonPreview_ExportXps_Caption": "XPS Dosyası",
  "PreviewStringId.RibbonPreview_ExportXps_Description": "XPS",
  "PreviewStringId.RibbonPreview_FillBackground_Caption": "Sayfa Rengi",
  "PreviewStringId.RibbonPreview_FillBackground_STipContent": "Doküman sayflarının arkaplanı için bir renk seçin.",
  "PreviewStringId.RibbonPreview_FillBackground_STipTitle": "Arkaplan Rengi",
  "PreviewStringId.RibbonPreview_Find_Caption": "Ara",
  "PreviewStringId.RibbonPreview_Find_STipContent": "Ara",
  "PreviewStringId.RibbonPreview_Find_STipTitle": "Ara",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsModerate_Caption": "Orta Derece",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsModerate_Description": "Orta Derece",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsNarrow_Caption": "Dar",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsNarrow_Description": "Dar",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsNormal_Caption": "Normal",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsNormal_Description": "Normal",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsWide_Caption": "Geniş",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMarginsWide_Description": "Geniş",
  "PreviewStringId.RibbonPreview_GalleryItem_PageMargins_Description": "Üst:\t\t{0}\t\tAlt:\t\t{1}\nSol:\t\t {2}\t\tSağ:\t\t   {3}",
  "PreviewStringId.RibbonPreview_GalleryItem_PageOrientationLandscape_Caption": "Yatay",
  "PreviewStringId.RibbonPreview_GalleryItem_PageOrientationPortrait_Caption": "Dikey",
  "PreviewStringId.RibbonPreview_GalleryItem_PaperSize_Description": "{0} x {1}",
  "PreviewStringId.RibbonPreview_HandTool_Caption": "El Aracı",
  "PreviewStringId.RibbonPreview_HandTool_STipContent": "El Aracı",
  "PreviewStringId.RibbonPreview_HandTool_STipTitle": "El Aracı",
  "PreviewStringId.RibbonPreview_HighlightEditingFields_Caption": "Alanları düzenleme",
  "PreviewStringId.RibbonPreview_HighlightEditingFields_STipContent": "Vurgu tüm düzenleme alanları hızlı bir şekilde belge öğeleri düzenlenebilir olan keşfetmek için.",
  "PreviewStringId.RibbonPreview_Magnifier_Caption": "Büyüteç",
  "PreviewStringId.RibbonPreview_Magnifier_STipContent": "Büyüteç",
  "PreviewStringId.RibbonPreview_Magnifier_STipTitle": "Büyüteç",
  "PreviewStringId.RibbonPreview_MultiplePages_Caption": "Çoklu Sayfa",
  "PreviewStringId.RibbonPreview_MultiplePages_STipContent": "Çoklu Sayfa",
  "PreviewStringId.RibbonPreview_MultiplePages_STipTitle": "Çoklu Sayfa",
  "PreviewStringId.RibbonPreview_Open_Caption": "Aç",
  "PreviewStringId.RibbonPreview_Open_STipContent": "Aç",
  "PreviewStringId.RibbonPreview_Open_STipTitle": "Aç (Ctrl + O)",
  "PreviewStringId.RibbonPreview_PageGroup_Background": "Sayfa Arkaplanı",
  "PreviewStringId.RibbonPreview_PageGroup_Close": "Kapat",
  "PreviewStringId.RibbonPreview_PageGroup_Document": "Doküman",
  "PreviewStringId.RibbonPreview_PageGroup_Export": "Dışarı Aktar",
  "PreviewStringId.RibbonPreview_PageGroup_Navigation": "Gezinme",
  "PreviewStringId.RibbonPreview_PageGroup_PageSetup": "Sayfa Düzeni",
  "PreviewStringId.RibbonPreview_PageGroup_PageSetup_STipContent": "Sayfa Düzeni",
  "PreviewStringId.RibbonPreview_PageGroup_PageSetup_STipTitle": "Sayfa Düzeni",
  "PreviewStringId.RibbonPreview_PageGroup_Print": "Yazdır",
  "PreviewStringId.RibbonPreview_PageGroup_Zoom": "Yakınlaştır",
  "PreviewStringId.RibbonPreview_PageMargins_Caption": "Kenar Boşlukları",
  "PreviewStringId.RibbonPreview_PageMargins_STipContent": "Kenar Boşlukları",
  "PreviewStringId.RibbonPreview_PageMargins_STipTitle": "Kenar Boşlukları",
  "PreviewStringId.RibbonPreview_PageOrientation_Caption": "Yön",
  "PreviewStringId.RibbonPreview_PageOrientation_STipContent": "Yön",
  "PreviewStringId.RibbonPreview_PageOrientation_STipTitle": "Sayfa Yönü",
  "PreviewStringId.RibbonPreview_PageSetup_Caption": "Kişisel Kenar Boşlukları...",
  "PreviewStringId.RibbonPreview_PageSetup_STipContent": "Sayfa Düzeni dialogunu göster",
  "PreviewStringId.RibbonPreview_PageSetup_STipTitle": "Sayfa Düzeni",
  "PreviewStringId.RibbonPreview_PageText": "Yazdırma Önizleme",
  "PreviewStringId.RibbonPreview_PaperSize_Caption": "Boyut",
  "PreviewStringId.RibbonPreview_PaperSize_STipContent": "Dokümanın sayfa boyutunu seçin",
  "PreviewStringId.RibbonPreview_PaperSize_STipTitle": "Sayfa Boyutu",
  "PreviewStringId.RibbonPreview_Parameters_Caption": "Değişkenler",
  "PreviewStringId.RibbonPreview_Parameters_STipContent": "Değişkenler Panelini aç",
  "PreviewStringId.RibbonPreview_Parameters_STipTitle": "Değişkenler",
  "PreviewStringId.RibbonPreview_Pointer_Caption": "İmleç",
  "PreviewStringId.RibbonPreview_Pointer_STipContent": "İmleç",
  "PreviewStringId.RibbonPreview_Pointer_STipTitle": "İmleç",
  "PreviewStringId.RibbonPreview_PrintDirect_Caption": "Hızlı Yazdır",
  "PreviewStringId.RibbonPreview_PrintDirect_STipContent": "Hızlı Yazdır",
  "PreviewStringId.RibbonPreview_PrintDirect_STipTitle": "Hızlı Yazdır",
  "PreviewStringId.RibbonPreview_Print_Caption": "Yazdır",
  "PreviewStringId.RibbonPreview_Print_STipContent": "Yazdır",
  "PreviewStringId.RibbonPreview_Print_STipTitle": "Yazdır",
  "PreviewStringId.RibbonPreview_Save_Caption": "Kaydet",
  "PreviewStringId.RibbonPreview_Save_STipContent": "Kaydet",
  "PreviewStringId.RibbonPreview_Save_STipTitle": "Kaydet",
  "PreviewStringId.RibbonPreview_Scale_Caption": "Ölçek",
  "PreviewStringId.RibbonPreview_Scale_STipContent": "Ölçek",
  "PreviewStringId.RibbonPreview_Scale_STipTitle": "Ölçek",
  "PreviewStringId.RibbonPreview_SendCsv_Caption": "CSV Dosyası",
  "PreviewStringId.RibbonPreview_SendCsv_Description": "CSV Dosyası",
  "PreviewStringId.RibbonPreview_SendCsv_STipContent": "Dokümanı CSV dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendCsv_STipTitle": "CSV ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendDocx_Caption": "DOCX dosya",
  "PreviewStringId.RibbonPreview_SendDocx_Description": "Microsoft Word belgesi",
  "PreviewStringId.RibbonPreview_SendDocx_STipContent": "DOCX için belgeyi dışa aktarın ve e-postaya iliştir.",
  "PreviewStringId.RibbonPreview_SendDocx_STipTitle": "E-posta olarak DOCX",
  "PreviewStringId.RibbonPreview_SendFile_Caption": "E-Posta",
  "PreviewStringId.RibbonPreview_SendFile_STipContent": "Dokümanı geçerli formatlardan birinde bir dosyaya aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendFile_STipTitle": "E-Posta...",
  "PreviewStringId.RibbonPreview_SendGraphic_Caption": "Resim Dosyası",
  "PreviewStringId.RibbonPreview_SendGraphic_Description": "BMP, GIF, JPEG, PNG, TIFF, EMF, WMF",
  "PreviewStringId.RibbonPreview_SendGraphic_STipContent": "Dokümanı Resim dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendGraphic_STipTitle": "Resim ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendMht_Caption": "MHT Dosyası",
  "PreviewStringId.RibbonPreview_SendMht_Description": "Tek Dosya Web Sayfası",
  "PreviewStringId.RibbonPreview_SendMht_STipContent": "Dokümanı MHT dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendMht_STipTitle": "MHT ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendPdf_Caption": "PDF Dosyası",
  "PreviewStringId.RibbonPreview_SendPdf_Description": "Adobe Taşınabilir Doküman Formatı",
  "PreviewStringId.RibbonPreview_SendPdf_STipContent": "Dokümanı PDF dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendPdf_STipTitle": "PDF ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendRtf_Caption": "RTF Dosyası",
  "PreviewStringId.RibbonPreview_SendRtf_Description": "Zengin Metin Formatı",
  "PreviewStringId.RibbonPreview_SendRtf_STipContent": "Dokümanı RTF dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendRtf_STipTitle": "PDF ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendTxt_Caption": "Metin Dosyası",
  "PreviewStringId.RibbonPreview_SendTxt_Description": "Metin Dosyası",
  "PreviewStringId.RibbonPreview_SendTxt_STipContent": "Dokümanı Metin dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendTxt_STipTitle": "Metin ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendXls_Caption": "XLS Dosyası",
  "PreviewStringId.RibbonPreview_SendXls_Description": "Microsoft Excel Workbook",
  "PreviewStringId.RibbonPreview_SendXls_STipContent": "Dokümanı XLS dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendXls_STipTitle": "XLS ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendXlsx_Caption": "XLSX Dosyası",
  "PreviewStringId.RibbonPreview_SendXlsx_Description": "Microsoft Excel çalışma kitabı",
  "PreviewStringId.RibbonPreview_SendXlsx_STipContent": "Dokümanı XLSX dosyasına aktar ve e-posta'ya ekle",
  "PreviewStringId.RibbonPreview_SendXlsx_STipTitle": "XLSX ekli e-posta oluştur",
  "PreviewStringId.RibbonPreview_SendXps_Caption": "XPS Dosyası",
  "PreviewStringId.RibbonPreview_SendXps_Description": "XPS",
  "PreviewStringId.RibbonPreview_ShowFirstPage_Caption": "İlk Sayfa",
  "PreviewStringId.RibbonPreview_ShowFirstPage_STipContent": "İlk Sayfa",
  "PreviewStringId.RibbonPreview_ShowFirstPage_STipTitle": "İlk Sayfa (Home)",
  "PreviewStringId.RibbonPreview_ShowLastPage_Caption": "Son Sayfa",
  "PreviewStringId.RibbonPreview_ShowLastPage_STipContent": "Son Sayfa",
  "PreviewStringId.RibbonPreview_ShowLastPage_STipTitle": "Son Sayfa (End)",
  "PreviewStringId.RibbonPreview_ShowNextPage_Caption": "Sonraki Sayfa",
  "PreviewStringId.RibbonPreview_ShowNextPage_STipContent": "Sonraki Sayfa",
  "PreviewStringId.RibbonPreview_ShowNextPage_STipTitle": "Sonraki Sayfa (Right Arrow)",
  "PreviewStringId.RibbonPreview_ShowPrevPage_Caption": "Önceki Sayfa",
  "PreviewStringId.RibbonPreview_ShowPrevPage_STipContent": "Önceki Sayfa",
  "PreviewStringId.RibbonPreview_ShowPrevPage_STipTitle": "Önceki Sayfa (Left Arrow)",
  "PreviewStringId.RibbonPreview_Thumbnails_Caption": "Küçük resimler",
  "PreviewStringId.RibbonPreview_Thumbnails_STipTitle": "Küçük resimler",
  "PreviewStringId.RibbonPreview_Watermark_Caption": "Filigran",
  "PreviewStringId.RibbonPreview_Watermark_STipContent": "Filigran",
  "PreviewStringId.RibbonPreview_Watermark_STipTitle": "Filigran",
  "PreviewStringId.RibbonPreview_ZoomExact_Caption": "Değer:",
  "PreviewStringId.RibbonPreview_ZoomIn_Caption": "Yakınlaştır",
  "PreviewStringId.RibbonPreview_ZoomIn_STipContent": "Doküman önizleme yakınlaştırma seviyesini yükselt",
  "PreviewStringId.RibbonPreview_ZoomIn_STipTitle": "Yakınlaştır",
  "PreviewStringId.RibbonPreview_ZoomOut_Caption": "Uzaklaştır",
  "PreviewStringId.RibbonPreview_ZoomOut_STipContent": "Doküman önizleme yakınlaştırma seviyesini azalt",
  "PreviewStringId.RibbonPreview_ZoomOut_STipTitle": "Uzaklaştır",
  "PreviewStringId.RibbonPreview_Zoom_Caption": "Yakınlaştır",
  "PreviewStringId.RibbonPreview_Zoom_STipContent": "Doküman önizlemenin yakınlaştırma seviyesini değiştir",
  "PreviewStringId.RibbonPreview_Zoom_STipTitle": "Yakınlaştır",
  "PreviewStringId.SB_PageInfo": "{0} / {1}",
  "PreviewStringId.SB_PageNone": "Yok",
  "PreviewStringId.SB_PageOfPages": "Sayfa {0} / {1}",
  "PreviewStringId.SB_PageOfPagesHint": "Belge sayfa numarası. Sayfaya Git iletişim kutusunu açmak için tıklayınız.",
  "PreviewStringId.SB_TTip_Stop": "Dur",
  "PreviewStringId.SB_ZoomFactor": "Yakınlaştırma Oranı:",
  "PreviewStringId.SaveDlg_FilterBmp": "BMP Bitmap Formatı",
  "PreviewStringId.SaveDlg_FilterCsv": "CSV Dokümanı",
  "PreviewStringId.SaveDlg_FilterEmf": "EMF Gelişmiş Windows Temel Dosyası",
  "PreviewStringId.SaveDlg_FilterGif": "GIF Graphics Interchange Formatı",
  "PreviewStringId.SaveDlg_FilterHtm": "HTML Dokümanı",
  "PreviewStringId.SaveDlg_FilterJpeg": "JPEG File Interchange Formatı",
  "PreviewStringId.SaveDlg_FilterMht": "MHT Dokümanı",
  "PreviewStringId.SaveDlg_FilterNativeFormat": "Asıl Format",
  "PreviewStringId.SaveDlg_FilterPdf": "PDF Dokümanı",
  "PreviewStringId.SaveDlg_FilterPng": "PNG Portable Network Graphics Formatı",
  "PreviewStringId.SaveDlg_FilterRtf": "Zengin Metin Dokümanı",
  "PreviewStringId.SaveDlg_FilterTiff": "TIFF Tag Image File Formatı",
  "PreviewStringId.SaveDlg_FilterTxt": "Metin Dokümanı",
  "PreviewStringId.SaveDlg_FilterWmf": "WMF Windows Temel Dosyası",
  "PreviewStringId.SaveDlg_FilterXls": "XLS Dokümanı",
  "PreviewStringId.SaveDlg_FilterXlsx": "XLSX Dokümanı",
  "PreviewStringId.SaveDlg_FilterXps": "XPS Dokümanı",
  "PreviewStringId.SaveDlg_Title": "Farklı Kaydet",
  "PreviewStringId.ScalePopup_AdjustTo": "Ayarlar:",
  "PreviewStringId.ScalePopup_FitTo": "Sığdır:",
  "PreviewStringId.ScalePopup_NormalSize": "% normal boyut",
  "PreviewStringId.ScalePopup_PagesWide": "Sayfa genişliği",
  "PreviewStringId.ScrollingInfo_Page": "Sayfa",
  "PreviewStringId.SearchPanel_EnterTextToSearch": "aramak için metni girin",
  "PreviewStringId.SearchPanel_MatchCase": "Harf eşleştir",
  "PreviewStringId.SignatureCaptions_Location": "Yeri:",
  "PreviewStringId.TB_TTip_Backgr": "Arkaplan",
  "PreviewStringId.TB_TTip_Close": "Önizlemeyi Kapat",
  "PreviewStringId.TB_TTip_Customize": "Kişiselleştir",
  "PreviewStringId.TB_TTip_EditPageHF": "Başlık ve Altlık",
  "PreviewStringId.TB_TTip_Export": "Dokümanı Dışarı Aktar",
  "PreviewStringId.TB_TTip_FirstPage": "İlk Sayfa",
  "PreviewStringId.TB_TTip_HandTool": "El Aracı",
  "PreviewStringId.TB_TTip_LastPage": "Son Sayfa",
  "PreviewStringId.TB_TTip_Magnifier": "Büyüteç",
  "PreviewStringId.TB_TTip_Map": "Doküman Haritası",
  "PreviewStringId.TB_TTip_MultiplePages": "Çoklu Sayfa",
  "PreviewStringId.TB_TTip_NextPage": "Sonraki Sayfa",
  "PreviewStringId.TB_TTip_Open": "Aç",
  "PreviewStringId.TB_TTip_PageSetup": "Sayfa Düzenleme",
  "PreviewStringId.TB_TTip_Parameters": "Değişkenler",
  "PreviewStringId.TB_TTip_PreviousPage": "Önceki Sayfa",
  "PreviewStringId.TB_TTip_Print": "Yazdır",
  "PreviewStringId.TB_TTip_PrintDirect": "Hızlı Yazdır",
  "PreviewStringId.TB_TTip_Save": "Kaydet",
  "PreviewStringId.TB_TTip_Scale": "Ölçeklendir",
  "PreviewStringId.TB_TTip_Search": "Ara",
  "PreviewStringId.TB_TTip_Send": "E-posta ile gönder",
  "PreviewStringId.TB_TTip_Thumbnails": "Küçük resimler",
  "PreviewStringId.TB_TTip_Watermark": "Filigran",
  "PreviewStringId.TB_TTip_Zoom": "Yakınlaştırma",
  "PreviewStringId.TB_TTip_ZoomIn": "Yakınlaştır",
  "PreviewStringId.TB_TTip_ZoomOut": "Uzaklaştır",
  "PreviewStringId.WMForm_Direction_BackwardDiagonal": "Geri Köşegen",
  "PreviewStringId.WMForm_Direction_ForwardDiagonal": "İleri Köşegen",
  "PreviewStringId.WMForm_Direction_Horizontal": "Yatay",
  "PreviewStringId.WMForm_Direction_Vertical": "Dikey",
  "PreviewStringId.WMForm_HorzAlign_Center": "Orta",
  "PreviewStringId.WMForm_HorzAlign_Left": "Sol",
  "PreviewStringId.WMForm_HorzAlign_Right": "Sağ",
  "PreviewStringId.WMForm_ImageClip": "Kırp",
  "PreviewStringId.WMForm_ImageStretch": "Uzat",
  "PreviewStringId.WMForm_ImageZoom": "Yakınlaştır",
  "PreviewStringId.WMForm_PictureDlg_Title": "Resim Seç",
  "PreviewStringId.WMForm_VertAlign_Bottom": "Alt",
  "PreviewStringId.WMForm_VertAlign_Middle": "Orta",
  "PreviewStringId.WMForm_VertAlign_Top": "Üst",
  "PreviewStringId.WMForm_Watermark_Asap": "En Kısa Zamanda",
  "PreviewStringId.WMForm_Watermark_Confidential": "GİZLİ",
  "PreviewStringId.WMForm_Watermark_Copy": "KOPYA",
  "PreviewStringId.WMForm_Watermark_DoNotCopy": "KOPYALANAMAZ",
  "PreviewStringId.WMForm_Watermark_Draft": "TASARI",
  "PreviewStringId.WMForm_Watermark_Evaluation": "DEĞERLENDİRME",
  "PreviewStringId.WMForm_Watermark_Original": "ASIL",
  "PreviewStringId.WMForm_Watermark_Personal": "KİŞİSEL",
  "PreviewStringId.WMForm_Watermark_Sample": "ÖRNEK",
  "PreviewStringId.WMForm_Watermark_TopSecret": "ÇOK GİZLİ",
  "PreviewStringId.WMForm_Watermark_Urgent": "ACİL",
  "PreviewStringId.WaitForm_Caption": "Lütfen bekleyin",
  "PreviewStringId.WatermarkTypePicture": "(Resim)",
  "PreviewStringId.WatermarkTypeText": "(Yazı)",
  "ReportBoxDesignerStringId.Wizard_LabelInformation_Description": "Ürün ve onun kimliğini belirterek önceden tanımlanmış etiketlerden birini seçin",
  "ReportBoxDesignerStringId.Wizard_MasterDetailAddGroupingLevel_Description": "Seçili raporlarındaki verileri gruplandırma. Her grup için bir veya daha fazla alan belirtebilirsiniz.",
  "StringId.Cancel": "İptal",
  "StringId.CheckChecked": "Seçili",
  "StringId.CheckIndeterminate": "Orta",
  "StringId.CheckUnchecked": "Seçili değil",
  "StringId.DefaultBooleanDefault": "Varsayılan",
  "StringId.DefaultBooleanFalse": "Yanlış",
  "StringId.DefaultBooleanTrue": "Gerçek",
  "StringId.FilterAggregateAvg": "Ortalama",
  "StringId.FilterAggregateCount": "Sayı",
  "StringId.FilterAggregateExists": "Var",
  "StringId.FilterAggregateMax": "En çok",
  "StringId.FilterAggregateMin": "En az",
  "StringId.FilterAggregateSum": "Toplam",
  "StringId.FilterClauseAnyOf": "Herhangi biri",
  "StringId.FilterClauseBeginsWith": "İle başlayan",
  "StringId.FilterClauseBetween": "Arasında",
  "StringId.FilterClauseContains": "İçeren",
  "StringId.FilterClauseDoesNotContain": "İçermeyen",
  "StringId.FilterClauseDoesNotEqual": "Eşit değil",
  "StringId.FilterClauseEndsWith": "İle biten",
  "StringId.FilterClauseEquals": "Eşit",
  "StringId.FilterClauseGreater": "Büyük",
  "StringId.FilterClauseGreaterOrEqual": "Büyük eşit",
  "StringId.FilterClauseIsNotNull": "Null değil",
  "StringId.FilterClauseIsNotNullOrEmpty": "Boş değil",
  "StringId.FilterClauseIsNull": "Null",
  "StringId.FilterClauseIsNullOrEmpty": "Boş",
  "StringId.FilterClauseLess": "Küçük",
  "StringId.FilterClauseLessOrEqual": "Küçük eşit",
  "StringId.FilterClauseLike": "Benzer",
  "StringId.FilterClauseNoneOf": "Hiçbiri değil",
  "StringId.FilterClauseNotBetween": "Arasında değil",
  "StringId.FilterClauseNotLike": "Benzer değil",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalBeyondThisYear": "Bu yıl daha sonra mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalEarlierThisMonth": "Bu ay daha önce mi",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalEarlierThisWeek": "Bu hafta daha önce mi",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalEarlierThisYear": "Bu yıl daha önce mi",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalLastWeek": "Geçen hafta mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalLaterThisMonth": "Bu ay daha sonra mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalLaterThisWeek": "Bu hafta daha sonra mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalLaterThisYear": "Bu yıl daha sonra mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalNextWeek": "Gelecek hafta mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalPriorThisYear": "Bu yıldan önce mi",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalToday": "Bugün mü",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalTomorrow": "Yarın mı",
  "StringId.FilterCriteriaToStringFunctionIsOutlookIntervalYesterday": "Dün mü",
  "StringId.FilterEmptyEnter": "<bir değer girin>",
  "StringId.FilterGroupAnd": "Ve",
  "StringId.FilterGroupNotAnd": "Ve değil",
  "StringId.FilterGroupNotOr": "Veya değil",
  "StringId.FilterGroupOr": "Veya",
  "StringId.FilterMenuConditionAdd": "Koşul Ekle",
  "StringId.FilterMenuGroupAdd": "Grup Ekle",
  "StringId.OK": "TAMAM",
  "System.Boolean.False": "Hayır",
  "System.Boolean.True": "Evet",
  "System.Collections.CollectionBase": "(Koleksiyon)",
  "System.Drawing.Bitmap": "Bit eşlem",
  "System.Drawing.Drawing2D.LinearGradientMode.BackwardDiagonal": "Geri Köşegen",
  "System.Drawing.Drawing2D.LinearGradientMode.ForwardDiagonal": "İleri Köşegen",
  "System.Drawing.Drawing2D.LinearGradientMode.Horizontal": "Yatay",
  "System.Drawing.Drawing2D.LinearGradientMode.Vertical": "Dikey",
  "System.Drawing.Font.Bold": "Kalın",
  "System.Drawing.Font.GdiCharSet": "GDI Karakter Seti",
  "System.Drawing.Font.GdiVerticalFont": "GDI Dikey Yazı Tipi",
  "System.Drawing.Font.Italic": "Yana Yatık",
  "System.Drawing.Font.Name": "Adı",
  "System.Drawing.Font.Size": "Boyut",
  "System.Drawing.Font.Strikeout": "Üstü Çizili",
  "System.Drawing.Font.Underline": "Altı Çizili",
  "System.Drawing.Font.Unit": "Birim",
  "System.Drawing.GraphicsUnit.Document": "Belge",
  "System.Drawing.GraphicsUnit.Point": "Nokta",
  "System.Drawing.Image.HorizontalResolution": "Yatay Çözünürlük",
  "System.Drawing.Image.PhysicalDimension": "Fiziksel Boyut",
  "System.Drawing.Image.PixelFormat": "Pixel Biçimi",
  "System.Drawing.Image.RawFormat": "Ham Biçim",
  "System.Drawing.Image.Size": "Boyut",
  "System.Drawing.Image.Tag": "Etiket",
  "System.Drawing.Image.VerticalResolution": "Dikey Çözünürlük",
  "System.Drawing.Imaging.Metafile": "Meta dosyası",
  "System.Drawing.Printing.PaperKind.A2": "A2",
  "System.Drawing.Printing.PaperKind.A3": "A3",
  "System.Drawing.Printing.PaperKind.A3Extra": "A3 Ekstra",
  "System.Drawing.Printing.PaperKind.A3ExtraTransverse": "A3 Ekstra Enine",
  "System.Drawing.Printing.PaperKind.A3Rotated": "A3 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.A3Transverse": "A3 Enine",
  "System.Drawing.Printing.PaperKind.A4": "A4",
  "System.Drawing.Printing.PaperKind.A4Extra": "A4 Ekstra",
  "System.Drawing.Printing.PaperKind.A4Plus": "A4 Artı",
  "System.Drawing.Printing.PaperKind.A4Rotated": "A4 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.A4Small": "A4 Küçük",
  "System.Drawing.Printing.PaperKind.A4Transverse": "A4 Enine",
  "System.Drawing.Printing.PaperKind.A5": "A5",
  "System.Drawing.Printing.PaperKind.A5Extra": "A5 Ekstra",
  "System.Drawing.Printing.PaperKind.A5Rotated": "A5 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.A5Transverse": "A5 Enine",
  "System.Drawing.Printing.PaperKind.A6": "A6",
  "System.Drawing.Printing.PaperKind.A6Rotated": "A6 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.APlus": "SuperA/SuperA/A4",
  "System.Drawing.Printing.PaperKind.B4": "B4",
  "System.Drawing.Printing.PaperKind.B4Envelope": "B4 Zarf",
  "System.Drawing.Printing.PaperKind.B4JisRotated": "JIS B4 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.B5": "B5",
  "System.Drawing.Printing.PaperKind.B5Envelope": "B5 Zarf",
  "System.Drawing.Printing.PaperKind.B5Extra": "ISO B5 Ekstra",
  "System.Drawing.Printing.PaperKind.B5JisRotated": "JIS B5 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.B5Transverse": "JIS B5 Enine",
  "System.Drawing.Printing.PaperKind.B6Envelope": "B6 Zarf",
  "System.Drawing.Printing.PaperKind.B6Jis": "JIS B6",
  "System.Drawing.Printing.PaperKind.B6JisRotated": "JIS B6 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.BPlus": "SuperB/SuperB/A3",
  "System.Drawing.Printing.PaperKind.C3Envelope": "C3 Zarf",
  "System.Drawing.Printing.PaperKind.C4Envelope": "C4 Zarf",
  "System.Drawing.Printing.PaperKind.C5Envelope": "C5 Zarf",
  "System.Drawing.Printing.PaperKind.C65Envelope": "C65 Zarf",
  "System.Drawing.Printing.PaperKind.C6Envelope": "C6 Zarf",
  "System.Drawing.Printing.PaperKind.CSheet": "C sayfa",
  "System.Drawing.Printing.PaperKind.Custom": "Özel",
  "System.Drawing.Printing.PaperKind.DLEnvelope": "DL Zarf",
  "System.Drawing.Printing.PaperKind.DSheet": "D Sayfa",
  "System.Drawing.Printing.PaperKind.ESheet": "E Sayfa",
  "System.Drawing.Printing.PaperKind.Executive": "Yönetici",
  "System.Drawing.Printing.PaperKind.Folio": "Folyo",
  "System.Drawing.Printing.PaperKind.GermanLegalFanfold": "Alman yasal Fanfold",
  "System.Drawing.Printing.PaperKind.GermanStandardFanfold": "Alman Standart Fanfold",
  "System.Drawing.Printing.PaperKind.InviteEnvelope": "Davetiye Zarfı",
  "System.Drawing.Printing.PaperKind.IsoB4": "Iso B4",
  "System.Drawing.Printing.PaperKind.ItalyEnvelope": "İtalya zarf",
  "System.Drawing.Printing.PaperKind.JapaneseDoublePostcard": "Japon Çift Kartpostal",
  "System.Drawing.Printing.PaperKind.JapaneseDoublePostcardRotated": "Japon Çift Kartpostal Döndürülmüş",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeChouNumber3": "Japon Zarf Chou Numara 3",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeChouNumber3Rotated": "Japon Zarf Chou Numara 3 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeChouNumber4": "Japon Zarf Chou Numara 4",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeChouNumber4Rotated": "Japon Zarf Chou Numara 4 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeKakuNumber2": "Japon Zarf Kaku Numara 2",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeKakuNumber2Rotated": "Japon Zarf Kaku Numara 2 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeKakuNumber3": "Japon Zarf Kaku Numara 3",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeKakuNumber3Rotated": "Japon Zarf Kaku Numara 3 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeYouNumber4": "Japon Zarf sayı 4",
  "System.Drawing.Printing.PaperKind.JapaneseEnvelopeYouNumber4Rotated": "Japon Zarf You Numara 4 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.JapanesePostcard": "Japon Kartpostal",
  "System.Drawing.Printing.PaperKind.JapanesePostcardRotated": "Japon Kartpostal Döndürülmüş",
  "System.Drawing.Printing.PaperKind.Ledger": "Genel muhasebe",
  "System.Drawing.Printing.PaperKind.Legal": "Yasal",
  "System.Drawing.Printing.PaperKind.LegalExtra": "Yasal ekstra",
  "System.Drawing.Printing.PaperKind.Letter": "Mektup",
  "System.Drawing.Printing.PaperKind.LetterExtra": "Mektup Ekstra",
  "System.Drawing.Printing.PaperKind.LetterExtraTransverse": "Mektup Ekstra Enine",
  "System.Drawing.Printing.PaperKind.LetterPlus": "Harf artı",
  "System.Drawing.Printing.PaperKind.LetterRotated": "Mektup Döndürülmüş",
  "System.Drawing.Printing.PaperKind.LetterSmall": "Küçük harf",
  "System.Drawing.Printing.PaperKind.LetterTransverse": "Mektup Enine",
  "System.Drawing.Printing.PaperKind.MonarchEnvelope": "Monarch Zarf",
  "System.Drawing.Printing.PaperKind.Note": "Not",
  "System.Drawing.Printing.PaperKind.Number10Envelope": "Numara 10 Zarf",
  "System.Drawing.Printing.PaperKind.Number11Envelope": "11 Numaralı zarfı",
  "System.Drawing.Printing.PaperKind.Number12Envelope": "Numara 12 Zarf",
  "System.Drawing.Printing.PaperKind.Number14Envelope": "Numara 14 Zarf",
  "System.Drawing.Printing.PaperKind.Number9Envelope": "Numara 9 Zarf",
  "System.Drawing.Printing.PaperKind.PersonalEnvelope": "Kişisel zarf (6 3/4)",
  "System.Drawing.Printing.PaperKind.Prc16K": "PRC 16 K",
  "System.Drawing.Printing.PaperKind.Prc16KRotated": "PRC 16 K döndürülmüş",
  "System.Drawing.Printing.PaperKind.Prc32K": "PRC 32 K",
  "System.Drawing.Printing.PaperKind.Prc32KBig": "Prc 32K büyük",
  "System.Drawing.Printing.PaperKind.Prc32KBigRotated": "Büyük döndürülmüş Prc 32 K",
  "System.Drawing.Printing.PaperKind.Prc32KRotated": "PRC 32 K döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber1": "PRC Zarf Numara 1",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber10": "PRC Zarf Numara 10",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber10Rotated": "PRC Zarf Numara 10 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber1Rotated": "PRC Zarf Numara 1 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber2": "PRC Zarf Numara 2",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber2Rotated": "PRC Zarf Numara 2 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber3": "PRC Zarf Numara 3",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber3Rotated": "PRC Zarf Numara 3 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber4": "PRC Zarf Numara 4",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber4Rotated": "PRC Zarf Numara 4 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber5": "PRC Zarf Numara 5",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber5Rotated": "PRC Zarf Numara 5 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber6": "PRC Zarf Numara 6",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber6Rotated": "PRC Zarf Numara 6 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber7": "PRC Zarf Numara 7",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber7Rotated": "PRC Zarf Numara 7 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber8": "PRC Zarf Numara 8",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber8Rotated": "PRC Zarf Numara 8 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber9": "PRC Zarf Numara 9",
  "System.Drawing.Printing.PaperKind.PrcEnvelopeNumber9Rotated": "PRC Zarf Numara 9 Döndürülmüş",
  "System.Drawing.Printing.PaperKind.Quarto": "Quarto",
  "System.Drawing.Printing.PaperKind.Standard10x11": "Standart 10 x 11",
  "System.Drawing.Printing.PaperKind.Standard10x14": "Standart 10 x 14",
  "System.Drawing.Printing.PaperKind.Standard11x17": "Standart 11 x 17",
  "System.Drawing.Printing.PaperKind.Standard12x11": "Standart 12 x 11",
  "System.Drawing.Printing.PaperKind.Standard15x11": "Standart 15 x 11",
  "System.Drawing.Printing.PaperKind.Standard9x11": "Standart 9 x 11",
  "System.Drawing.Printing.PaperKind.Statement": "Deyim",
  "System.Drawing.Printing.PaperKind.Tabloid": "Tabloid",
  "System.Drawing.Printing.PaperKind.TabloidExtra": "Tabloid Ekstra",
  "System.Drawing.Printing.PaperKind.USStandardFanfold": "ABD standart sürekli form",
  "System.Drawing.Size.Height": "Yükseklik",
  "System.Drawing.Size.Width": "Genişlik",
  "System.Drawing.SizeF.Height": "Boy",
  "System.Drawing.SizeF.Width": "En"
}
